var items = {
  "block.minecraft.acacia_button": "Akaciaknapp",
  "block.minecraft.acacia_door": "Akaciadörr",
  "block.minecraft.acacia_fence": "Akaciastaket",
  "block.minecraft.acacia_fence_gate": "Akaciagrind",
  "block.minecraft.acacia_hanging_sign": "Hängande akaciaskylt",
  "block.minecraft.acacia_leaves": "Akacialöv",
  "block.minecraft.acacia_log": "Akaciastam",
  "block.minecraft.acacia_planks": "Akaciaplankor",
  "block.minecraft.acacia_pressure_plate": "Akaciatryckplatta",
  "block.minecraft.acacia_sapling": "Akaciaplanta",
  "block.minecraft.acacia_shelf": "Akaciahylla",
  "block.minecraft.acacia_sign": "Akaciaskylt",
  "block.minecraft.acacia_slab": "Akaciaplatta",
  "block.minecraft.acacia_stairs": "Akaciatrappa",
  "block.minecraft.acacia_trapdoor": "Akaciafallucka",
  "block.minecraft.acacia_wall_hanging_sign": "Hängande akaciaskylt på vägg",
  "block.minecraft.acacia_wall_sign": "Akaciaskylt på vägg",
  "block.minecraft.acacia_wood": "Akaciaträ",
  "block.minecraft.activator_rail": "Aktiveringsräls",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Gräslök",
  "block.minecraft.amethyst_block": "Ametistblock",
  "block.minecraft.amethyst_cluster": "Ametistkluster",
  "block.minecraft.ancient_debris": "Forntida spillror",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitplatta",
  "block.minecraft.andesite_stairs": "Andesittrappa",
  "block.minecraft.andesite_wall": "Andesitmur",
  "block.minecraft.anvil": "Städ",
  "block.minecraft.attached_melon_stem": "Ansluten melonstjälk",
  "block.minecraft.attached_pumpkin_stem": "Ansluten pumpastjälk",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Azalealöv",
  "block.minecraft.azure_bluet": "Porslinsstjärna",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bambublock",
  "block.minecraft.bamboo_button": "Bambuknapp",
  "block.minecraft.bamboo_door": "Bambudörr",
  "block.minecraft.bamboo_fence": "Bambustaket",
  "block.minecraft.bamboo_fence_gate": "Bambugrind",
  "block.minecraft.bamboo_hanging_sign": "Hängande bambuskylt",
  "block.minecraft.bamboo_mosaic": "Bambumosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambumosaikplatta",
  "block.minecraft.bamboo_mosaic_stairs": "Bambumosaiktrappa",
  "block.minecraft.bamboo_planks": "Bambuplankor",
  "block.minecraft.bamboo_pressure_plate": "Bambutryckplatta",
  "block.minecraft.bamboo_sapling": "Bambuskott",
  "block.minecraft.bamboo_shelf": "Bambuhylla",
  "block.minecraft.bamboo_sign": "Bambuskylt",
  "block.minecraft.bamboo_slab": "Bambuplatta",
  "block.minecraft.bamboo_stairs": "Bambutrappa",
  "block.minecraft.bamboo_trapdoor": "Bambufallucka",
  "block.minecraft.bamboo_wall_hanging_sign": "Hängande bambuskylt på vägg",
  "block.minecraft.bamboo_wall_sign": "Bambuskylt på vägg",
  "block.minecraft.banner.base.black": "Svart bakgrund",
  "block.minecraft.banner.base.blue": "Blå bakgrund",
  "block.minecraft.banner.base.brown": "Brun bakgrund",
  "block.minecraft.banner.base.cyan": "Turkos bakgrund",
  "block.minecraft.banner.base.gray": "Grå bakgrund",
  "block.minecraft.banner.base.green": "Grön bakgrund",
  "block.minecraft.banner.base.light_blue": "Ljusblå bakgrund",
  "block.minecraft.banner.base.light_gray": "Ljusgrå bakgrund",
  "block.minecraft.banner.base.lime": "Limegrön bakgrund",
  "block.minecraft.banner.base.magenta": "Ljuslila bakgrund",
  "block.minecraft.banner.base.orange": "Orange bakgrund",
  "block.minecraft.banner.base.pink": "Rosa bakgrund",
  "block.minecraft.banner.base.purple": "Lila bakgrund",
  "block.minecraft.banner.base.red": "Röd bakgrund",
  "block.minecraft.banner.base.white": "Vit bakgrund",
  "block.minecraft.banner.base.yellow": "Gul bakgrund",
  "block.minecraft.banner.border.black": "Svart ram",
  "block.minecraft.banner.border.blue": "Blå ram",
  "block.minecraft.banner.border.brown": "Brun ram",
  "block.minecraft.banner.border.cyan": "Turkos ram",
  "block.minecraft.banner.border.gray": "Grå ram",
  "block.minecraft.banner.border.green": "Grön ram",
  "block.minecraft.banner.border.light_blue": "Ljusblå ram",
  "block.minecraft.banner.border.light_gray": "Ljusgrå ram",
  "block.minecraft.banner.border.lime": "Limegrön ram",
  "block.minecraft.banner.border.magenta": "Ljuslila ram",
  "block.minecraft.banner.border.orange": "Orange ram",
  "block.minecraft.banner.border.pink": "Rosa ram",
  "block.minecraft.banner.border.purple": "Lila ram",
  "block.minecraft.banner.border.red": "Röd ram",
  "block.minecraft.banner.border.white": "Vit ram",
  "block.minecraft.banner.border.yellow": "Gul ram",
  "block.minecraft.banner.bricks.black": "Svart tegelmönster",
  "block.minecraft.banner.bricks.blue": "Blått tegelmönster",
  "block.minecraft.banner.bricks.brown": "Brunt tegelmönster",
  "block.minecraft.banner.bricks.cyan": "Turkost tegelmönster",
  "block.minecraft.banner.bricks.gray": "Grått tegelmönster",
  "block.minecraft.banner.bricks.green": "Grönt tegelmönster",
  "block.minecraft.banner.bricks.light_blue": "Ljusblått tegelmönster",
  "block.minecraft.banner.bricks.light_gray": "Ljusgrått tegelmönster",
  "block.minecraft.banner.bricks.lime": "Limegrönt tegelmönster",
  "block.minecraft.banner.bricks.magenta": "Ljuslila tegelmönster",
  "block.minecraft.banner.bricks.orange": "Orange tegelmönster",
  "block.minecraft.banner.bricks.pink": "Rosa tegelmönster",
  "block.minecraft.banner.bricks.purple": "Lila tegelmönster",
  "block.minecraft.banner.bricks.red": "Rött tegelmönster",
  "block.minecraft.banner.bricks.white": "Vitt tegelmönster",
  "block.minecraft.banner.bricks.yellow": "Gult tegelmönster",
  "block.minecraft.banner.circle.black": "Svart cirkel",
  "block.minecraft.banner.circle.blue": "Blå cirkel",
  "block.minecraft.banner.circle.brown": "Brun cirkel",
  "block.minecraft.banner.circle.cyan": "Turkos cirkel",
  "block.minecraft.banner.circle.gray": "Grå cirkel",
  "block.minecraft.banner.circle.green": "Grön cirkel",
  "block.minecraft.banner.circle.light_blue": "Ljusblå cirkel",
  "block.minecraft.banner.circle.light_gray": "Ljusgrå cirkel",
  "block.minecraft.banner.circle.lime": "Limegrön cirkel",
  "block.minecraft.banner.circle.magenta": "Ljuslila cirkel",
  "block.minecraft.banner.circle.orange": "Orange cirkel",
  "block.minecraft.banner.circle.pink": "Rosa cirkel",
  "block.minecraft.banner.circle.purple": "Lila cirkel",
  "block.minecraft.banner.circle.red": "Röd cirkel",
  "block.minecraft.banner.circle.white": "Vit cirkel",
  "block.minecraft.banner.circle.yellow": "Gul cirkel",
  "block.minecraft.banner.creeper.black": "Svart creeper",
  "block.minecraft.banner.creeper.blue": "Blå creeper",
  "block.minecraft.banner.creeper.brown": "Brun creeper",
  "block.minecraft.banner.creeper.cyan": "Turkos creeper",
  "block.minecraft.banner.creeper.gray": "Grå creeper",
  "block.minecraft.banner.creeper.green": "Grön creeper",
  "block.minecraft.banner.creeper.light_blue": "Ljusblå creeper",
  "block.minecraft.banner.creeper.light_gray": "Ljusgrå creeper",
  "block.minecraft.banner.creeper.lime": "Limegrön creeper",
  "block.minecraft.banner.creeper.magenta": "Ljuslila creeper",
  "block.minecraft.banner.creeper.orange": "Orange creeper",
  "block.minecraft.banner.creeper.pink": "Rosa creeper",
  "block.minecraft.banner.creeper.purple": "Lila creeper",
  "block.minecraft.banner.creeper.red": "Röd creeper",
  "block.minecraft.banner.creeper.white": "Vit creeper",
  "block.minecraft.banner.creeper.yellow": "Gul creeper",
  "block.minecraft.banner.cross.black": "Svart kryss",
  "block.minecraft.banner.cross.blue": "Blått kryss",
  "block.minecraft.banner.cross.brown": "Brunt kryss",
  "block.minecraft.banner.cross.cyan": "Turkost kryss",
  "block.minecraft.banner.cross.gray": "Grått kryss",
  "block.minecraft.banner.cross.green": "Grönt kryss",
  "block.minecraft.banner.cross.light_blue": "Ljusblått kryss",
  "block.minecraft.banner.cross.light_gray": "Ljusgrått kryss",
  "block.minecraft.banner.cross.lime": "Limegrönt kryss",
  "block.minecraft.banner.cross.magenta": "Ljuslila kryss",
  "block.minecraft.banner.cross.orange": "Orange kryss",
  "block.minecraft.banner.cross.pink": "Lila kryss",
  "block.minecraft.banner.cross.purple": "Lila kryss",
  "block.minecraft.banner.cross.red": "Rött kryss",
  "block.minecraft.banner.cross.white": "Vitt kryss",
  "block.minecraft.banner.cross.yellow": "Gult kryss",
  "block.minecraft.banner.curly_border.black": "Svart taggig ram",
  "block.minecraft.banner.curly_border.blue": "Blå taggig ram",
  "block.minecraft.banner.curly_border.brown": "Brun taggig ram",
  "block.minecraft.banner.curly_border.cyan": "Turkos taggig ram",
  "block.minecraft.banner.curly_border.gray": "Grå taggig ram",
  "block.minecraft.banner.curly_border.green": "Grön taggig ram",
  "block.minecraft.banner.curly_border.light_blue": "Ljusblå taggig ram",
  "block.minecraft.banner.curly_border.light_gray": "Ljusgrå taggig ram",
  "block.minecraft.banner.curly_border.lime": "Limegrön taggig ram",
  "block.minecraft.banner.curly_border.magenta": "Ljuslila taggig ram",
  "block.minecraft.banner.curly_border.orange": "Orange taggig ram",
  "block.minecraft.banner.curly_border.pink": "Rosa taggig ram",
  "block.minecraft.banner.curly_border.purple": "Lila taggig ram",
  "block.minecraft.banner.curly_border.red": "Röd taggig ram",
  "block.minecraft.banner.curly_border.white": "Vit taggig ram",
  "block.minecraft.banner.curly_border.yellow": "Gul taggig ram",
  "block.minecraft.banner.diagonal_left.black": "Svart triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.blue": "Blå triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.brown": "Brun triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.cyan": "Turkos triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.gray": "Grå triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.green": "Grön triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.light_blue": "Ljusblå triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.light_gray": "Ljusgrå triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.lime": "Limegrön triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.magenta": "Ljuslila triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.orange": "Orange triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.pink": "Rosa triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.purple": "Lila triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.red": "Röd triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.white": "Vit triangel uppe till vänster",
  "block.minecraft.banner.diagonal_left.yellow": "Gul triangel uppe till vänster",
  "block.minecraft.banner.diagonal_right.black": "Svart triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.blue": "Blå triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.brown": "Brun triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.cyan": "Turkos triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.gray": "Grå triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.green": "Grön triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.light_blue": "Ljusblå triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.light_gray": "Ljusgrå triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.lime": "Limegrön triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.magenta": "Ljuslila triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.orange": "Orange triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.pink": "Rosa triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.purple": "Lila triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.red": "Röd triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.white": "Vit triangel uppe till höger",
  "block.minecraft.banner.diagonal_right.yellow": "Gul triangel uppe till höger",
  "block.minecraft.banner.diagonal_up_left.black": "Svart triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.blue": "Blå triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.brown": "Brun triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkos triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.gray": "Grå triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.green": "Grön triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ljusblå triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ljusgrå triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.lime": "Limegrön triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.magenta": "Ljuslila triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.purple": "Lila triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.red": "Röd triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.white": "Vit triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gul triangel nere till vänster",
  "block.minecraft.banner.diagonal_up_right.black": "Svart triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.blue": "Blå triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.brown": "Brun triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkos triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.gray": "Grå triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.green": "Grön triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Ljusblå triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Ljusgrå triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.lime": "Limegrön triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.magenta": "Ljuslila triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.purple": "Lila triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.red": "Röd triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.white": "Vit triangel nere till höger",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gul triangel nere till höger",
  "block.minecraft.banner.flow.black": "Svart virvel",
  "block.minecraft.banner.flow.blue": "Blå virvel",
  "block.minecraft.banner.flow.brown": "Brun virvel",
  "block.minecraft.banner.flow.cyan": "Turkos virvel",
  "block.minecraft.banner.flow.gray": "Grå virvel",
  "block.minecraft.banner.flow.green": "Grön virvel",
  "block.minecraft.banner.flow.light_blue": "Ljusblå virvel",
  "block.minecraft.banner.flow.light_gray": "Ljusgrå virvel",
  "block.minecraft.banner.flow.lime": "Limegrön virvel",
  "block.minecraft.banner.flow.magenta": "Ljuslila virvel",
  "block.minecraft.banner.flow.orange": "Orange virvel",
  "block.minecraft.banner.flow.pink": "Rosa virvel",
  "block.minecraft.banner.flow.purple": "Lila virvel",
  "block.minecraft.banner.flow.red": "Röd virvel",
  "block.minecraft.banner.flow.white": "Vit virvel",
  "block.minecraft.banner.flow.yellow": "Gul virvel",
  "block.minecraft.banner.flower.black": "Svart blomma",
  "block.minecraft.banner.flower.blue": "Blå blomma",
  "block.minecraft.banner.flower.brown": "Brun blomma",
  "block.minecraft.banner.flower.cyan": "Turkos blomma",
  "block.minecraft.banner.flower.gray": "Grå blomma",
  "block.minecraft.banner.flower.green": "Grön blomma",
  "block.minecraft.banner.flower.light_blue": "Ljusblå blomma",
  "block.minecraft.banner.flower.light_gray": "Ljusgrå blomma",
  "block.minecraft.banner.flower.lime": "Limegrön blomma",
  "block.minecraft.banner.flower.magenta": "Ljuslila blomma",
  "block.minecraft.banner.flower.orange": "Orange blomma",
  "block.minecraft.banner.flower.pink": "Rosa blomma",
  "block.minecraft.banner.flower.purple": "Lila blomma",
  "block.minecraft.banner.flower.red": "Röd blomma",
  "block.minecraft.banner.flower.white": "Vit blomma",
  "block.minecraft.banner.flower.yellow": "Gul blomma",
  "block.minecraft.banner.globe.black": "Svart glob",
  "block.minecraft.banner.globe.blue": "Blå glob",
  "block.minecraft.banner.globe.brown": "Brun glob",
  "block.minecraft.banner.globe.cyan": "Turkos glob",
  "block.minecraft.banner.globe.gray": "Grå glob",
  "block.minecraft.banner.globe.green": "Grön glob",
  "block.minecraft.banner.globe.light_blue": "Ljusblå glob",
  "block.minecraft.banner.globe.light_gray": "Ljusgrå glob",
  "block.minecraft.banner.globe.lime": "Limegrön glob",
  "block.minecraft.banner.globe.magenta": "Ljuslila glob",
  "block.minecraft.banner.globe.orange": "Orange glob",
  "block.minecraft.banner.globe.pink": "Rosa glob",
  "block.minecraft.banner.globe.purple": "Lila glob",
  "block.minecraft.banner.globe.red": "Röd glob",
  "block.minecraft.banner.globe.white": "Vit glob",
  "block.minecraft.banner.globe.yellow": "Gul glob",
  "block.minecraft.banner.gradient.black": "Svart övergång ovanifrån",
  "block.minecraft.banner.gradient.blue": "Blå övergång ovanifrån",
  "block.minecraft.banner.gradient.brown": "Brun övergång ovanifrån",
  "block.minecraft.banner.gradient.cyan": "Turkos övergång ovanifrån",
  "block.minecraft.banner.gradient.gray": "Grå övergång ovanifrån",
  "block.minecraft.banner.gradient.green": "Grön övergång ovanifrån",
  "block.minecraft.banner.gradient.light_blue": "Ljusblå övergång ovanifrån",
  "block.minecraft.banner.gradient.light_gray": "Ljusgrå övergång ovanifrån",
  "block.minecraft.banner.gradient.lime": "Limegrön övergång ovanifrån",
  "block.minecraft.banner.gradient.magenta": "Ljuslila övergång ovanifrån",
  "block.minecraft.banner.gradient.orange": "Orange övergång ovanifrån",
  "block.minecraft.banner.gradient.pink": "Rosa övergång ovanifrån",
  "block.minecraft.banner.gradient.purple": "Lila övergång ovanifrån",
  "block.minecraft.banner.gradient.red": "Röd övergång ovanifrån",
  "block.minecraft.banner.gradient.white": "Vit övergång ovanifrån",
  "block.minecraft.banner.gradient.yellow": "Gul övergång ovanifrån",
  "block.minecraft.banner.gradient_up.black": "Svart övergång nedanifrån",
  "block.minecraft.banner.gradient_up.blue": "Blå övergång nedanifrån",
  "block.minecraft.banner.gradient_up.brown": "Brun övergång nedanifrån",
  "block.minecraft.banner.gradient_up.cyan": "Turkos övergång nedanifrån",
  "block.minecraft.banner.gradient_up.gray": "Grå övergång nedanifrån",
  "block.minecraft.banner.gradient_up.green": "Grön övergång nedanifrån",
  "block.minecraft.banner.gradient_up.light_blue": "Ljusblå övergång nedanifrån",
  "block.minecraft.banner.gradient_up.light_gray": "Ljusgrå övergång nedanifrån",
  "block.minecraft.banner.gradient_up.lime": "Limegrön övergång nedanifrån",
  "block.minecraft.banner.gradient_up.magenta": "Ljuslila övergång nedanifrån",
  "block.minecraft.banner.gradient_up.orange": "Orange övergång nedanifrån",
  "block.minecraft.banner.gradient_up.pink": "Rosa övergång nedanifrån",
  "block.minecraft.banner.gradient_up.purple": "Lila övergång nedanifrån",
  "block.minecraft.banner.gradient_up.red": "Röd övergång nedanifrån",
  "block.minecraft.banner.gradient_up.white": "Vit övergång nedanifrån",
  "block.minecraft.banner.gradient_up.yellow": "Gul övergång nedanifrån",
  "block.minecraft.banner.guster.black": "Svart vindväsen",
  "block.minecraft.banner.guster.blue": "Blått vindväsen",
  "block.minecraft.banner.guster.brown": "Brunt vindväsen",
  "block.minecraft.banner.guster.cyan": "Turkost vindväsen",
  "block.minecraft.banner.guster.gray": "Grått vindväsen",
  "block.minecraft.banner.guster.green": "Grönt vindväsen",
  "block.minecraft.banner.guster.light_blue": "Ljusblått vindväsen",
  "block.minecraft.banner.guster.light_gray": "Ljusgrått vindväsen",
  "block.minecraft.banner.guster.lime": "Limegrönt vindväsen",
  "block.minecraft.banner.guster.magenta": "Ljuslila vindväsen",
  "block.minecraft.banner.guster.orange": "Orange vindväsen",
  "block.minecraft.banner.guster.pink": "Rosa vindväsen",
  "block.minecraft.banner.guster.purple": "Lila vindväsen",
  "block.minecraft.banner.guster.red": "Rött vindväsen",
  "block.minecraft.banner.guster.white": "Vitt vindväsen",
  "block.minecraft.banner.guster.yellow": "Gult vindväsen",
  "block.minecraft.banner.half_horizontal.black": "Svart överhalva",
  "block.minecraft.banner.half_horizontal.blue": "Blå överhalva",
  "block.minecraft.banner.half_horizontal.brown": "Brun överhalva",
  "block.minecraft.banner.half_horizontal.cyan": "Turkos överhalva",
  "block.minecraft.banner.half_horizontal.gray": "Grå överhalva",
  "block.minecraft.banner.half_horizontal.green": "Grön överhalva",
  "block.minecraft.banner.half_horizontal.light_blue": "Ljusblå överhalva",
  "block.minecraft.banner.half_horizontal.light_gray": "Ljusgrå överhalva",
  "block.minecraft.banner.half_horizontal.lime": "Limegrön överhalva",
  "block.minecraft.banner.half_horizontal.magenta": "Ljuslila överhalva",
  "block.minecraft.banner.half_horizontal.orange": "Orange överhalva",
  "block.minecraft.banner.half_horizontal.pink": "Rosa överhalva",
  "block.minecraft.banner.half_horizontal.purple": "Lila överhalva",
  "block.minecraft.banner.half_horizontal.red": "Röd överhalva",
  "block.minecraft.banner.half_horizontal.white": "Vit överhalva",
  "block.minecraft.banner.half_horizontal.yellow": "Gul överhalva",
  "block.minecraft.banner.half_horizontal_bottom.black": "Svart underhalva",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Blå underhalva",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brun underhalva",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkos underhalva",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Grå underhalva",
  "block.minecraft.banner.half_horizontal_bottom.green": "Grön underhalva",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Ljusblå underhalva",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Ljusgrå underhalva",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Limegrön underhalva",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Ljuslila underhalva",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Orange underhalva",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rosa underhalva",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Lila underhalva",
  "block.minecraft.banner.half_horizontal_bottom.red": "Röd underhalva",
  "block.minecraft.banner.half_horizontal_bottom.white": "Vit underhalva",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Gul underhalva",
  "block.minecraft.banner.half_vertical.black": "Svart vänsterhalva",
  "block.minecraft.banner.half_vertical.blue": "Blå vänsterhalva",
  "block.minecraft.banner.half_vertical.brown": "Brun vänsterhalva",
  "block.minecraft.banner.half_vertical.cyan": "Turkos vänsterhalva",
  "block.minecraft.banner.half_vertical.gray": "Grå vänsterhalva",
  "block.minecraft.banner.half_vertical.green": "Grön vänsterhalva",
  "block.minecraft.banner.half_vertical.light_blue": "Ljusblå vänsterhalva",
  "block.minecraft.banner.half_vertical.light_gray": "Ljusgrå vänsterhalva",
  "block.minecraft.banner.half_vertical.lime": "Limegrön vänsterhalva",
  "block.minecraft.banner.half_vertical.magenta": "Ljuslila vänsterhalva",
  "block.minecraft.banner.half_vertical.orange": "Orange vänsterhalva",
  "block.minecraft.banner.half_vertical.pink": "Rosa vänsterhalva",
  "block.minecraft.banner.half_vertical.purple": "Lila vänsterhalva",
  "block.minecraft.banner.half_vertical.red": "Röd vänsterhalva",
  "block.minecraft.banner.half_vertical.white": "Vit vänsterhalva",
  "block.minecraft.banner.half_vertical.yellow": "Gul vänsterhalva",
  "block.minecraft.banner.half_vertical_right.black": "Svart högerhalva",
  "block.minecraft.banner.half_vertical_right.blue": "Blå högerhalva",
  "block.minecraft.banner.half_vertical_right.brown": "Brun högerhalva",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkos högerhalva",
  "block.minecraft.banner.half_vertical_right.gray": "Grå högerhalva",
  "block.minecraft.banner.half_vertical_right.green": "Grön högerhalva",
  "block.minecraft.banner.half_vertical_right.light_blue": "Ljusblå högerhalva",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ljusgrå högerhalva",
  "block.minecraft.banner.half_vertical_right.lime": "Limegrön högerhalva",
  "block.minecraft.banner.half_vertical_right.magenta": "Ljuslila högerhalva",
  "block.minecraft.banner.half_vertical_right.orange": "Orange högerhalva",
  "block.minecraft.banner.half_vertical_right.pink": "Rosa högerhalva",
  "block.minecraft.banner.half_vertical_right.purple": "Lila högerhalva",
  "block.minecraft.banner.half_vertical_right.red": "Röd högerhalva",
  "block.minecraft.banner.half_vertical_right.white": "Vit högerhalva",
  "block.minecraft.banner.half_vertical_right.yellow": "Gul högerhalva",
  "block.minecraft.banner.mojang.black": "Svart mojäng",
  "block.minecraft.banner.mojang.blue": "Blå mojäng",
  "block.minecraft.banner.mojang.brown": "Brun mojäng",
  "block.minecraft.banner.mojang.cyan": "Turkos mojäng",
  "block.minecraft.banner.mojang.gray": "Grå mojäng",
  "block.minecraft.banner.mojang.green": "Grön mojäng",
  "block.minecraft.banner.mojang.light_blue": "Ljusblå mojäng",
  "block.minecraft.banner.mojang.light_gray": "Ljusgrå mojäng",
  "block.minecraft.banner.mojang.lime": "Limegrön mojäng",
  "block.minecraft.banner.mojang.magenta": "Ljuslila mojäng",
  "block.minecraft.banner.mojang.orange": "Orange mojäng",
  "block.minecraft.banner.mojang.pink": "Rosa mojäng",
  "block.minecraft.banner.mojang.purple": "Lila mojäng",
  "block.minecraft.banner.mojang.red": "Röd mojäng",
  "block.minecraft.banner.mojang.white": "Vit mojäng",
  "block.minecraft.banner.mojang.yellow": "Gul mojäng",
  "block.minecraft.banner.piglin.black": "Svart tryne",
  "block.minecraft.banner.piglin.blue": "Blått tryne",
  "block.minecraft.banner.piglin.brown": "Brunt tryne",
  "block.minecraft.banner.piglin.cyan": "Turkost tryne",
  "block.minecraft.banner.piglin.gray": "Grått tryne",
  "block.minecraft.banner.piglin.green": "Grönt tryne",
  "block.minecraft.banner.piglin.light_blue": "Ljusblått tryne",
  "block.minecraft.banner.piglin.light_gray": "Ljusgrått tryne",
  "block.minecraft.banner.piglin.lime": "Limegrönt tryne",
  "block.minecraft.banner.piglin.magenta": "Ljuslila tryne",
  "block.minecraft.banner.piglin.orange": "Orange tryne",
  "block.minecraft.banner.piglin.pink": "Rosa tryne",
  "block.minecraft.banner.piglin.purple": "Lila tryne",
  "block.minecraft.banner.piglin.red": "Rött tryne",
  "block.minecraft.banner.piglin.white": "Vitt tryne",
  "block.minecraft.banner.piglin.yellow": "Gult tryne",
  "block.minecraft.banner.rhombus.black": "Svart romb",
  "block.minecraft.banner.rhombus.blue": "Blå romb",
  "block.minecraft.banner.rhombus.brown": "Brun romb",
  "block.minecraft.banner.rhombus.cyan": "Turkos romb",
  "block.minecraft.banner.rhombus.gray": "Grå romb",
  "block.minecraft.banner.rhombus.green": "Grön romb",
  "block.minecraft.banner.rhombus.light_blue": "Ljusblå romb",
  "block.minecraft.banner.rhombus.light_gray": "Ljusgrå romb",
  "block.minecraft.banner.rhombus.lime": "Limegrön romb",
  "block.minecraft.banner.rhombus.magenta": "Ljuslila romb",
  "block.minecraft.banner.rhombus.orange": "Orange romb",
  "block.minecraft.banner.rhombus.pink": "Rosa romb",
  "block.minecraft.banner.rhombus.purple": "Lila romb",
  "block.minecraft.banner.rhombus.red": "Röd romb",
  "block.minecraft.banner.rhombus.white": "Vit romb",
  "block.minecraft.banner.rhombus.yellow": "Gul romb",
  "block.minecraft.banner.skull.black": "Svart dödskalle",
  "block.minecraft.banner.skull.blue": "Blå dödskalle",
  "block.minecraft.banner.skull.brown": "Brun dödskalle",
  "block.minecraft.banner.skull.cyan": "Turkos dödskalle",
  "block.minecraft.banner.skull.gray": "Grå dödskalle",
  "block.minecraft.banner.skull.green": "Grön dödskalle",
  "block.minecraft.banner.skull.light_blue": "Ljusblå dödskalle",
  "block.minecraft.banner.skull.light_gray": "Ljusgrå dödskalle",
  "block.minecraft.banner.skull.lime": "Limegrön dödskalle",
  "block.minecraft.banner.skull.magenta": "Ljuslila dödskalle",
  "block.minecraft.banner.skull.orange": "Orange dödskalle",
  "block.minecraft.banner.skull.pink": "Rosa dödskalle",
  "block.minecraft.banner.skull.purple": "Lila dödskalle",
  "block.minecraft.banner.skull.red": "Röd dödskalle",
  "block.minecraft.banner.skull.white": "Vit dödskalle",
  "block.minecraft.banner.skull.yellow": "Gul dödskalle",
  "block.minecraft.banner.small_stripes.black": "Svartrandig",
  "block.minecraft.banner.small_stripes.blue": "Blårandig",
  "block.minecraft.banner.small_stripes.brown": "Brunrandig",
  "block.minecraft.banner.small_stripes.cyan": "Turkosrandig",
  "block.minecraft.banner.small_stripes.gray": "Grårandig",
  "block.minecraft.banner.small_stripes.green": "Grönrandig",
  "block.minecraft.banner.small_stripes.light_blue": "Ljusblårandig",
  "block.minecraft.banner.small_stripes.light_gray": "Ljusgrårandig",
  "block.minecraft.banner.small_stripes.lime": "Limegrönrandig",
  "block.minecraft.banner.small_stripes.magenta": "Ljuslilarandig",
  "block.minecraft.banner.small_stripes.orange": "Orangerandig",
  "block.minecraft.banner.small_stripes.pink": "Rosarandig",
  "block.minecraft.banner.small_stripes.purple": "Lilarandig",
  "block.minecraft.banner.small_stripes.red": "Rödrandig",
  "block.minecraft.banner.small_stripes.white": "Vitrandig",
  "block.minecraft.banner.small_stripes.yellow": "Gulrandig",
  "block.minecraft.banner.square_bottom_left.black": "Svart nere till vänster",
  "block.minecraft.banner.square_bottom_left.blue": "Blå nere till vänster",
  "block.minecraft.banner.square_bottom_left.brown": "Brun nere till vänster",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkos nere till vänster",
  "block.minecraft.banner.square_bottom_left.gray": "Grå nere till vänster",
  "block.minecraft.banner.square_bottom_left.green": "Grön nere till vänster",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ljusblå nere till vänster",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ljusgrå nere till vänster",
  "block.minecraft.banner.square_bottom_left.lime": "Limegrön nere till vänster",
  "block.minecraft.banner.square_bottom_left.magenta": "Ljuslila nere till vänster",
  "block.minecraft.banner.square_bottom_left.orange": "Orange nere till vänster",
  "block.minecraft.banner.square_bottom_left.pink": "Rosa nere till vänster",
  "block.minecraft.banner.square_bottom_left.purple": "Lila nere till vänster",
  "block.minecraft.banner.square_bottom_left.red": "Röd nere till vänster",
  "block.minecraft.banner.square_bottom_left.white": "Vit nere till vänster",
  "block.minecraft.banner.square_bottom_left.yellow": "Gul nere till vänster",
  "block.minecraft.banner.square_bottom_right.black": "Svart nere till höger",
  "block.minecraft.banner.square_bottom_right.blue": "Blå nere till höger",
  "block.minecraft.banner.square_bottom_right.brown": "Brun nere till höger",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkos nere till höger",
  "block.minecraft.banner.square_bottom_right.gray": "Grå nere till höger",
  "block.minecraft.banner.square_bottom_right.green": "Grön nere till höger",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ljusblå nere till höger",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ljusgrå nere till höger",
  "block.minecraft.banner.square_bottom_right.lime": "Limegrön nere till höger",
  "block.minecraft.banner.square_bottom_right.magenta": "Ljuslila nere till höger",
  "block.minecraft.banner.square_bottom_right.orange": "Orange nere till höger",
  "block.minecraft.banner.square_bottom_right.pink": "Rosa nere till höger",
  "block.minecraft.banner.square_bottom_right.purple": "Lila nere till höger",
  "block.minecraft.banner.square_bottom_right.red": "Röd nere till höger",
  "block.minecraft.banner.square_bottom_right.white": "Vit nere till höger",
  "block.minecraft.banner.square_bottom_right.yellow": "Gul nere till höger",
  "block.minecraft.banner.square_top_left.black": "Svart uppe till vänster",
  "block.minecraft.banner.square_top_left.blue": "Blå uppe till vänster",
  "block.minecraft.banner.square_top_left.brown": "Brun uppe till vänster",
  "block.minecraft.banner.square_top_left.cyan": "Turkos uppe till vänster",
  "block.minecraft.banner.square_top_left.gray": "Grå uppe till vänster",
  "block.minecraft.banner.square_top_left.green": "Grön uppe till vänster",
  "block.minecraft.banner.square_top_left.light_blue": "Ljusblå uppe till vänster",
  "block.minecraft.banner.square_top_left.light_gray": "Ljusgrå uppe till vänster",
  "block.minecraft.banner.square_top_left.lime": "Limegrön uppe till vänster",
  "block.minecraft.banner.square_top_left.magenta": "Ljuslila uppe till vänster",
  "block.minecraft.banner.square_top_left.orange": "Orange uppe till vänster",
  "block.minecraft.banner.square_top_left.pink": "Rosa uppe till vänster",
  "block.minecraft.banner.square_top_left.purple": "Lila uppe till vänster",
  "block.minecraft.banner.square_top_left.red": "Röd uppe till vänster",
  "block.minecraft.banner.square_top_left.white": "Vit uppe till vänster",
  "block.minecraft.banner.square_top_left.yellow": "Gul uppe till vänster",
  "block.minecraft.banner.square_top_right.black": "Svart uppe till höger",
  "block.minecraft.banner.square_top_right.blue": "Blå uppe till höger",
  "block.minecraft.banner.square_top_right.brown": "Brun uppe till höger",
  "block.minecraft.banner.square_top_right.cyan": "Turkos uppe till höger",
  "block.minecraft.banner.square_top_right.gray": "Grå uppe till höger",
  "block.minecraft.banner.square_top_right.green": "Grön uppe till höger",
  "block.minecraft.banner.square_top_right.light_blue": "Ljusblå uppe till höger",
  "block.minecraft.banner.square_top_right.light_gray": "Ljusgrå uppe till höger",
  "block.minecraft.banner.square_top_right.lime": "Limegrön uppe till höger",
  "block.minecraft.banner.square_top_right.magenta": "Ljuslila uppe till höger",
  "block.minecraft.banner.square_top_right.orange": "Orange uppe till höger",
  "block.minecraft.banner.square_top_right.pink": "Rosa uppe till höger",
  "block.minecraft.banner.square_top_right.purple": "Lila uppe till höger",
  "block.minecraft.banner.square_top_right.red": "Röd uppe till höger",
  "block.minecraft.banner.square_top_right.white": "Vit uppe till höger",
  "block.minecraft.banner.square_top_right.yellow": "Gul uppe till höger",
  "block.minecraft.banner.straight_cross.black": "Svart kors",
  "block.minecraft.banner.straight_cross.blue": "Blått kors",
  "block.minecraft.banner.straight_cross.brown": "Brunt kors",
  "block.minecraft.banner.straight_cross.cyan": "Turkost kors",
  "block.minecraft.banner.straight_cross.gray": "Grått kors",
  "block.minecraft.banner.straight_cross.green": "Grönt kors",
  "block.minecraft.banner.straight_cross.light_blue": "Ljusblått kors",
  "block.minecraft.banner.straight_cross.light_gray": "Ljusgrått kors",
  "block.minecraft.banner.straight_cross.lime": "Limegrönt kors",
  "block.minecraft.banner.straight_cross.magenta": "Ljuslila kors",
  "block.minecraft.banner.straight_cross.orange": "Orange kors",
  "block.minecraft.banner.straight_cross.pink": "Rosa kors",
  "block.minecraft.banner.straight_cross.purple": "Lila kors",
  "block.minecraft.banner.straight_cross.red": "Rött kors",
  "block.minecraft.banner.straight_cross.white": "Vitt kors",
  "block.minecraft.banner.straight_cross.yellow": "Gult kors",
  "block.minecraft.banner.stripe_bottom.black": "Svart nederkant",
  "block.minecraft.banner.stripe_bottom.blue": "Blå nederkant",
  "block.minecraft.banner.stripe_bottom.brown": "Brun nederkant",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkos nederkant",
  "block.minecraft.banner.stripe_bottom.gray": "Grå nederkant",
  "block.minecraft.banner.stripe_bottom.green": "Grön nederkant",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ljusblå nederkant",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ljusgrå nederkant",
  "block.minecraft.banner.stripe_bottom.lime": "Limegrön nederkant",
  "block.minecraft.banner.stripe_bottom.magenta": "Ljuslila nederkant",
  "block.minecraft.banner.stripe_bottom.orange": "Orange nederkant",
  "block.minecraft.banner.stripe_bottom.pink": "Rosa nederkant",
  "block.minecraft.banner.stripe_bottom.purple": "Lila nederkant",
  "block.minecraft.banner.stripe_bottom.red": "Röd nederkant",
  "block.minecraft.banner.stripe_bottom.white": "Vit nederkant",
  "block.minecraft.banner.stripe_bottom.yellow": "Gul nederkant",
  "block.minecraft.banner.stripe_center.black": "Svart vertikalt streck",
  "block.minecraft.banner.stripe_center.blue": "Blått vertikalt streck",
  "block.minecraft.banner.stripe_center.brown": "Brunt vertikalt streck",
  "block.minecraft.banner.stripe_center.cyan": "Turkost vertikalt streck",
  "block.minecraft.banner.stripe_center.gray": "Grått vertikalt streck",
  "block.minecraft.banner.stripe_center.green": "Grönt vertikalt streck",
  "block.minecraft.banner.stripe_center.light_blue": "Ljusblått vertikalt streck",
  "block.minecraft.banner.stripe_center.light_gray": "Ljusgrått vertikalt streck",
  "block.minecraft.banner.stripe_center.lime": "Limegrönt vertikalt streck",
  "block.minecraft.banner.stripe_center.magenta": "Ljuslila vertikalt streck",
  "block.minecraft.banner.stripe_center.orange": "Orange vertikalt streck",
  "block.minecraft.banner.stripe_center.pink": "Rosa vertikalt streck",
  "block.minecraft.banner.stripe_center.purple": "Lila vertikalt streck",
  "block.minecraft.banner.stripe_center.red": "Rött vertikalt streck",
  "block.minecraft.banner.stripe_center.white": "Vitt vertikalt streck",
  "block.minecraft.banner.stripe_center.yellow": "Gult vertikalt streck",
  "block.minecraft.banner.stripe_downleft.black": "Svart omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.blue": "Blått omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.brown": "Brunt omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkost omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.gray": "Grått omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.green": "Grönt omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ljusblått omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ljusgrått omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.lime": "Limegrönt omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.magenta": "Ljuslila omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.orange": "Orange omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.pink": "Rosa omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.purple": "Lila omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.red": "Rött omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.white": "Vitt omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downleft.yellow": "Gult omvänt diagonalt streck",
  "block.minecraft.banner.stripe_downright.black": "Svart diagonalt streck",
  "block.minecraft.banner.stripe_downright.blue": "Blått diagonalt streck",
  "block.minecraft.banner.stripe_downright.brown": "Brunt diagonalt streck",
  "block.minecraft.banner.stripe_downright.cyan": "Turkost diagonalt streck",
  "block.minecraft.banner.stripe_downright.gray": "Grått diagonalt streck",
  "block.minecraft.banner.stripe_downright.green": "Grönt diagonalt streck",
  "block.minecraft.banner.stripe_downright.light_blue": "Ljusblått diagonalt streck",
  "block.minecraft.banner.stripe_downright.light_gray": "Ljusgrått diagonalt streck",
  "block.minecraft.banner.stripe_downright.lime": "Limegrönt diagonalt streck",
  "block.minecraft.banner.stripe_downright.magenta": "Ljuslila diagonalt streck",
  "block.minecraft.banner.stripe_downright.orange": "Orange diagonalt streck",
  "block.minecraft.banner.stripe_downright.pink": "Rosa diagonalt streck",
  "block.minecraft.banner.stripe_downright.purple": "Lila diagonalt streck",
  "block.minecraft.banner.stripe_downright.red": "Rött diagonalt streck",
  "block.minecraft.banner.stripe_downright.white": "Vitt diagonalt streck",
  "block.minecraft.banner.stripe_downright.yellow": "Gult diagonalt streck",
  "block.minecraft.banner.stripe_left.black": "Svart till vänster",
  "block.minecraft.banner.stripe_left.blue": "Blå till vänster",
  "block.minecraft.banner.stripe_left.brown": "Brun till vänster",
  "block.minecraft.banner.stripe_left.cyan": "Turkos till vänster",
  "block.minecraft.banner.stripe_left.gray": "Grå till vänster",
  "block.minecraft.banner.stripe_left.green": "Grön till vänster",
  "block.minecraft.banner.stripe_left.light_blue": "Ljusblå till vänster",
  "block.minecraft.banner.stripe_left.light_gray": "Ljusgrå till vänster",
  "block.minecraft.banner.stripe_left.lime": "Limegrön till vänster",
  "block.minecraft.banner.stripe_left.magenta": "Ljuslila till vänster",
  "block.minecraft.banner.stripe_left.orange": "Orange till vänster",
  "block.minecraft.banner.stripe_left.pink": "Rosa till vänster",
  "block.minecraft.banner.stripe_left.purple": "Lila till vänster",
  "block.minecraft.banner.stripe_left.red": "Röd till vänster",
  "block.minecraft.banner.stripe_left.white": "Vit till vänster",
  "block.minecraft.banner.stripe_left.yellow": "Gul till vänster",
  "block.minecraft.banner.stripe_middle.black": "Svart horisontellt streck",
  "block.minecraft.banner.stripe_middle.blue": "Blått horisontellt streck",
  "block.minecraft.banner.stripe_middle.brown": "Brunt horisontellt streck",
  "block.minecraft.banner.stripe_middle.cyan": "Turkost horisontellt streck",
  "block.minecraft.banner.stripe_middle.gray": "Grått horisontellt streck",
  "block.minecraft.banner.stripe_middle.green": "Grönt horisontellt streck",
  "block.minecraft.banner.stripe_middle.light_blue": "Ljusblått horisontellt streck",
  "block.minecraft.banner.stripe_middle.light_gray": "Ljusgrått horisontellt streck",
  "block.minecraft.banner.stripe_middle.lime": "Limegrönt horisontellt streck",
  "block.minecraft.banner.stripe_middle.magenta": "Ljuslila horisontellt streck",
  "block.minecraft.banner.stripe_middle.orange": "Orange horisontellt streck",
  "block.minecraft.banner.stripe_middle.pink": "Rosa horisontellt streck",
  "block.minecraft.banner.stripe_middle.purple": "Lila horisontellt streck",
  "block.minecraft.banner.stripe_middle.red": "Rött horisontellt streck",
  "block.minecraft.banner.stripe_middle.white": "Vitt horisontellt streck",
  "block.minecraft.banner.stripe_middle.yellow": "Gult horisontellt streck",
  "block.minecraft.banner.stripe_right.black": "Svart till höger",
  "block.minecraft.banner.stripe_right.blue": "Blå till höger",
  "block.minecraft.banner.stripe_right.brown": "Brun till höger",
  "block.minecraft.banner.stripe_right.cyan": "Turkos till höger",
  "block.minecraft.banner.stripe_right.gray": "Grå till höger",
  "block.minecraft.banner.stripe_right.green": "Grön till höger",
  "block.minecraft.banner.stripe_right.light_blue": "Ljusblå till höger",
  "block.minecraft.banner.stripe_right.light_gray": "Ljusgrå till höger",
  "block.minecraft.banner.stripe_right.lime": "Limegrön till höger",
  "block.minecraft.banner.stripe_right.magenta": "Ljuslila till höger",
  "block.minecraft.banner.stripe_right.orange": "Orange till höger",
  "block.minecraft.banner.stripe_right.pink": "Rosa till höger",
  "block.minecraft.banner.stripe_right.purple": "Lila till höger",
  "block.minecraft.banner.stripe_right.red": "Röd till höger",
  "block.minecraft.banner.stripe_right.white": "Vit till höger",
  "block.minecraft.banner.stripe_right.yellow": "Gul till höger",
  "block.minecraft.banner.stripe_top.black": "Svart överkant",
  "block.minecraft.banner.stripe_top.blue": "Blå överkant",
  "block.minecraft.banner.stripe_top.brown": "Brun överkant",
  "block.minecraft.banner.stripe_top.cyan": "Turkos överkant",
  "block.minecraft.banner.stripe_top.gray": "Grå överkant",
  "block.minecraft.banner.stripe_top.green": "Grön överkant",
  "block.minecraft.banner.stripe_top.light_blue": "Ljusblå överkant",
  "block.minecraft.banner.stripe_top.light_gray": "Ljusgrå överkant",
  "block.minecraft.banner.stripe_top.lime": "Limegrön överkant",
  "block.minecraft.banner.stripe_top.magenta": "Ljuslila överkant",
  "block.minecraft.banner.stripe_top.orange": "Orange överkant",
  "block.minecraft.banner.stripe_top.pink": "Rosa överkant",
  "block.minecraft.banner.stripe_top.purple": "Lila överkant",
  "block.minecraft.banner.stripe_top.red": "Röd överkant",
  "block.minecraft.banner.stripe_top.white": "Vit överkant",
  "block.minecraft.banner.stripe_top.yellow": "Gul överkant",
  "block.minecraft.banner.triangle_bottom.black": "Svart triangel nedtill",
  "block.minecraft.banner.triangle_bottom.blue": "Blå triangel nedtill",
  "block.minecraft.banner.triangle_bottom.brown": "Brun triangel nedtill",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkos triangel nedtill",
  "block.minecraft.banner.triangle_bottom.gray": "Grå triangel nedtill",
  "block.minecraft.banner.triangle_bottom.green": "Grön triangel nedtill",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ljusblå triangel nedtill",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ljusgrå triangel nedtill",
  "block.minecraft.banner.triangle_bottom.lime": "Limegrön triangel nedtill",
  "block.minecraft.banner.triangle_bottom.magenta": "Ljuslila triangel nedtill",
  "block.minecraft.banner.triangle_bottom.orange": "Orange triangel nedtill",
  "block.minecraft.banner.triangle_bottom.pink": "Rosa triangel nedtill",
  "block.minecraft.banner.triangle_bottom.purple": "Lila triangel nedtill",
  "block.minecraft.banner.triangle_bottom.red": "Röd triangel nedtill",
  "block.minecraft.banner.triangle_bottom.white": "Vit triangel nedtill",
  "block.minecraft.banner.triangle_bottom.yellow": "Gul triangel nedtill",
  "block.minecraft.banner.triangle_top.black": "Svart triangel upptill",
  "block.minecraft.banner.triangle_top.blue": "Blå triangel upptill",
  "block.minecraft.banner.triangle_top.brown": "Brun triangel upptill",
  "block.minecraft.banner.triangle_top.cyan": "Turkos triangel upptill",
  "block.minecraft.banner.triangle_top.gray": "Grå triangel upptill",
  "block.minecraft.banner.triangle_top.green": "Grön triangel upptill",
  "block.minecraft.banner.triangle_top.light_blue": "Ljusblå triangel upptill",
  "block.minecraft.banner.triangle_top.light_gray": "Ljusgrå triangel upptill",
  "block.minecraft.banner.triangle_top.lime": "Limegrön triangel upptill",
  "block.minecraft.banner.triangle_top.magenta": "Ljuslila triangel upptill",
  "block.minecraft.banner.triangle_top.orange": "Orange triangel upptill",
  "block.minecraft.banner.triangle_top.pink": "Rosa triangel upptill",
  "block.minecraft.banner.triangle_top.purple": "Lila triangel upptill",
  "block.minecraft.banner.triangle_top.red": "Röd triangel upptill",
  "block.minecraft.banner.triangle_top.white": "Vit triangel upptill",
  "block.minecraft.banner.triangle_top.yellow": "Gul triangel upptill",
  "block.minecraft.banner.triangles_bottom.black": "Svarta taggar nedtill",
  "block.minecraft.banner.triangles_bottom.blue": "Blåa taggar nedtill",
  "block.minecraft.banner.triangles_bottom.brown": "Bruna taggar nedtill",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkosa taggar nedtill",
  "block.minecraft.banner.triangles_bottom.gray": "Gråa taggar nedtill",
  "block.minecraft.banner.triangles_bottom.green": "Gröna taggar nedtill",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ljusblåa taggar nedtill",
  "block.minecraft.banner.triangles_bottom.light_gray": "Ljusgråa taggar nedtill",
  "block.minecraft.banner.triangles_bottom.lime": "Limegröna taggar nedtill",
  "block.minecraft.banner.triangles_bottom.magenta": "Ljuslila taggar nedtill",
  "block.minecraft.banner.triangles_bottom.orange": "Orangea taggar nedtill",
  "block.minecraft.banner.triangles_bottom.pink": "Rosa taggar nedtill",
  "block.minecraft.banner.triangles_bottom.purple": "Lila taggar nedtill",
  "block.minecraft.banner.triangles_bottom.red": "Röda taggar nedtill",
  "block.minecraft.banner.triangles_bottom.white": "Vita taggar nedtill",
  "block.minecraft.banner.triangles_bottom.yellow": "Gula taggar nedtill",
  "block.minecraft.banner.triangles_top.black": "Svarta taggar upptill",
  "block.minecraft.banner.triangles_top.blue": "Blåa taggar upptill",
  "block.minecraft.banner.triangles_top.brown": "Bruna taggar upptill",
  "block.minecraft.banner.triangles_top.cyan": "Turkosa taggar upptill",
  "block.minecraft.banner.triangles_top.gray": "Gråa taggar upptill",
  "block.minecraft.banner.triangles_top.green": "Gröna taggar upptill",
  "block.minecraft.banner.triangles_top.light_blue": "Ljusblåa taggar upptill",
  "block.minecraft.banner.triangles_top.light_gray": "Ljusgråa taggar upptill",
  "block.minecraft.banner.triangles_top.lime": "Limegröna taggar upptill",
  "block.minecraft.banner.triangles_top.magenta": "Ljuslila taggar upptill",
  "block.minecraft.banner.triangles_top.orange": "Orangea taggar upptill",
  "block.minecraft.banner.triangles_top.pink": "Rosa taggar upptill",
  "block.minecraft.banner.triangles_top.purple": "Lila taggar upptill",
  "block.minecraft.banner.triangles_top.red": "Röda taggar upptill",
  "block.minecraft.banner.triangles_top.white": "Vita taggar upptill",
  "block.minecraft.banner.triangles_top.yellow": "Gula taggar upptill",
  "block.minecraft.barrel": "Tunna",
  "block.minecraft.barrier": "Barriär",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Fyr",
  "block.minecraft.beacon.primary": "Primär kraft",
  "block.minecraft.beacon.secondary": "Sekundär kraft",
  "block.minecraft.bed.no_sleep": "Du kan bara sova på natten och i åskväder",
  "block.minecraft.bed.not_safe": "Du kan inte sova nu, det finns monster i närheten",
  "block.minecraft.bed.obstructed": "Den här sängen är blockerad",
  "block.minecraft.bed.occupied": "Den här sängen är upptagen",
  "block.minecraft.bed.too_far_away": "Du kan inte sova nu, sängen är för långt bort",
  "block.minecraft.bedrock": "Berggrund",
  "block.minecraft.bee_nest": "Bisamhälle",
  "block.minecraft.beehive": "Bikupa",
  "block.minecraft.beetroots": "Rödbetor",
  "block.minecraft.bell": "Ringklocka",
  "block.minecraft.big_dripleaf": "Stort dropplöv",
  "block.minecraft.big_dripleaf_stem": "Stor dropplövsstjälk",
  "block.minecraft.birch_button": "Björkknapp",
  "block.minecraft.birch_door": "Björkdörr",
  "block.minecraft.birch_fence": "Björkstaket",
  "block.minecraft.birch_fence_gate": "Björkgrind",
  "block.minecraft.birch_hanging_sign": "Hängande björkskylt",
  "block.minecraft.birch_leaves": "Björklöv",
  "block.minecraft.birch_log": "Björkstam",
  "block.minecraft.birch_planks": "Björkplankor",
  "block.minecraft.birch_pressure_plate": "Björktryckplatta",
  "block.minecraft.birch_sapling": "Björkplanta",
  "block.minecraft.birch_shelf": "Björkhylla",
  "block.minecraft.birch_sign": "Björkskylt",
  "block.minecraft.birch_slab": "Björkplatta",
  "block.minecraft.birch_stairs": "Björktrappa",
  "block.minecraft.birch_trapdoor": "Björkfallucka",
  "block.minecraft.birch_wall_hanging_sign": "Hängande björkskylt på vägg",
  "block.minecraft.birch_wall_sign": "Björkskylt på vägg",
  "block.minecraft.birch_wood": "Björkträ",
  "block.minecraft.black_banner": "Svart fana",
  "block.minecraft.black_bed": "Svart säng",
  "block.minecraft.black_candle": "Svart stearinljus",
  "block.minecraft.black_candle_cake": "Tårta med svart stearinljus",
  "block.minecraft.black_carpet": "Svart matta",
  "block.minecraft.black_concrete": "Svart betong",
  "block.minecraft.black_concrete_powder": "Svart betongpulver",
  "block.minecraft.black_glazed_terracotta": "Svartglaserad terrakotta",
  "block.minecraft.black_shulker_box": "Svart shulkerlåda",
  "block.minecraft.black_stained_glass": "Svartfärgat glas",
  "block.minecraft.black_stained_glass_pane": "Svartfärgad glasruta",
  "block.minecraft.black_terracotta": "Svart terrakotta",
  "block.minecraft.black_wool": "Svart ull",
  "block.minecraft.blackstone": "Svartsten",
  "block.minecraft.blackstone_slab": "Svartstensplatta",
  "block.minecraft.blackstone_stairs": "Svartstenstrappa",
  "block.minecraft.blackstone_wall": "Svartstensmur",
  "block.minecraft.blast_furnace": "Masugn",
  "block.minecraft.blue_banner": "Blå fana",
  "block.minecraft.blue_bed": "Blå säng",
  "block.minecraft.blue_candle": "Blått stearinljus",
  "block.minecraft.blue_candle_cake": "Tårta med blått stearinljus",
  "block.minecraft.blue_carpet": "Blå matta",
  "block.minecraft.blue_concrete": "Blå betong",
  "block.minecraft.blue_concrete_powder": "Blått betongpulver",
  "block.minecraft.blue_glazed_terracotta": "Blåglaserad terrakotta",
  "block.minecraft.blue_ice": "Blå is",
  "block.minecraft.blue_orchid": "Blå orkidé",
  "block.minecraft.blue_shulker_box": "Blå shulkerlåda",
  "block.minecraft.blue_stained_glass": "Blåfärgat glas",
  "block.minecraft.blue_stained_glass_pane": "Blåfärgad glasruta",
  "block.minecraft.blue_terracotta": "Blå terrakotta",
  "block.minecraft.blue_wool": "Blå ull",
  "block.minecraft.bone_block": "Benblock",
  "block.minecraft.bookshelf": "Bokhylla",
  "block.minecraft.brain_coral": "Hjärnkorall",
  "block.minecraft.brain_coral_block": "Hjärnkorallblock",
  "block.minecraft.brain_coral_fan": "Hjärnkorallfläkt",
  "block.minecraft.brain_coral_wall_fan": "Hjärnkorallfläkt på vägg",
  "block.minecraft.brewing_stand": "Brygdställ",
  "block.minecraft.brick_slab": "Tegelplatta",
  "block.minecraft.brick_stairs": "Tegeltrappa",
  "block.minecraft.brick_wall": "Tegelmur",
  "block.minecraft.bricks": "Tegel",
  "block.minecraft.brown_banner": "Brun fana",
  "block.minecraft.brown_bed": "Brun säng",
  "block.minecraft.brown_candle": "Brunt stearinljus",
  "block.minecraft.brown_candle_cake": "Tårta med brunt stearinljus",
  "block.minecraft.brown_carpet": "Brun matta",
  "block.minecraft.brown_concrete": "Brun betong",
  "block.minecraft.brown_concrete_powder": "Brunt betongpulver",
  "block.minecraft.brown_glazed_terracotta": "Brunglaserad terrakotta",
  "block.minecraft.brown_mushroom": "Brun svamp",
  "block.minecraft.brown_mushroom_block": "Brunt svampblock",
  "block.minecraft.brown_shulker_box": "Brun shulkerlåda",
  "block.minecraft.brown_stained_glass": "Brunfärgat glas",
  "block.minecraft.brown_stained_glass_pane": "Brunfärgad glasruta",
  "block.minecraft.brown_terracotta": "Brun terrakotta",
  "block.minecraft.brown_wool": "Brun ull",
  "block.minecraft.bubble_column": "Bubbelkolumn",
  "block.minecraft.bubble_coral": "Bubbelkorall",
  "block.minecraft.bubble_coral_block": "Bubbelkorallblock",
  "block.minecraft.bubble_coral_fan": "Bubbelkorallfläkt",
  "block.minecraft.bubble_coral_wall_fan": "Bubbelkorallfläkt på vägg",
  "block.minecraft.budding_amethyst": "Knoppande ametist",
  "block.minecraft.bush": "Buske",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblomma",
  "block.minecraft.cake": "Tårta",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrerad sculksensor",
  "block.minecraft.campfire": "Lägereld",
  "block.minecraft.candle": "Stearinljus",
  "block.minecraft.candle_cake": "Tårta med stearinljus",
  "block.minecraft.carrots": "Morötter",
  "block.minecraft.cartography_table": "Kartografbord",
  "block.minecraft.carved_pumpkin": "Skuren pumpa",
  "block.minecraft.cauldron": "Kittel",
  "block.minecraft.cave_air": "Grottluft",
  "block.minecraft.cave_vines": "Grottklätterväxt",
  "block.minecraft.cave_vines_plant": "Grottklätterväxtsplanta",
  "block.minecraft.chain": "Kedja",
  "block.minecraft.chain_command_block": "Kedjat kommandoblock",
  "block.minecraft.cherry_button": "Körsbärsknapp",
  "block.minecraft.cherry_door": "Körsbärsdörr",
  "block.minecraft.cherry_fence": "Körsbärsstaket",
  "block.minecraft.cherry_fence_gate": "Körsbärsgrind",
  "block.minecraft.cherry_hanging_sign": "Hängande körsbärsskylt",
  "block.minecraft.cherry_leaves": "Körsbärslöv",
  "block.minecraft.cherry_log": "Körsbärsstam",
  "block.minecraft.cherry_planks": "Körsbärsplankor",
  "block.minecraft.cherry_pressure_plate": "Körsbärstryckplatta",
  "block.minecraft.cherry_sapling": "Körsbärsplanta",
  "block.minecraft.cherry_shelf": "Körsbärshylla",
  "block.minecraft.cherry_sign": "Körsbärsskylt",
  "block.minecraft.cherry_slab": "Körsbärsplatta",
  "block.minecraft.cherry_stairs": "Körsbärstrappa",
  "block.minecraft.cherry_trapdoor": "Körsbärsfallucka",
  "block.minecraft.cherry_wall_hanging_sign": "Hängande körsbärsskylt på vägg",
  "block.minecraft.cherry_wall_sign": "Körsbärsskylt på vägg",
  "block.minecraft.cherry_wood": "Körsbärsträ",
  "block.minecraft.chest": "Kista",
  "block.minecraft.chipped_anvil": "Sprucket städ",
  "block.minecraft.chiseled_bookshelf": "Mejslad bokhylla",
  "block.minecraft.chiseled_copper": "Mejslad koppar",
  "block.minecraft.chiseled_deepslate": "Mejslad djupskiffer",
  "block.minecraft.chiseled_nether_bricks": "Mejslat nethertegel",
  "block.minecraft.chiseled_polished_blackstone": "Mejslad polerad svartsten",
  "block.minecraft.chiseled_quartz_block": "Mejslat kvartsblock",
  "block.minecraft.chiseled_red_sandstone": "Mejslad röd sandsten",
  "block.minecraft.chiseled_resin_bricks": "Mejslat hartstegel",
  "block.minecraft.chiseled_sandstone": "Mejslad sandsten",
  "block.minecraft.chiseled_stone_bricks": "Mejslad mursten",
  "block.minecraft.chiseled_tuff": "Mejslad tuff",
  "block.minecraft.chiseled_tuff_bricks": "Mejslad tuffmursten",
  "block.minecraft.chorus_flower": "Körblomma",
  "block.minecraft.chorus_plant": "Körplanta",
  "block.minecraft.clay": "Lera",
  "block.minecraft.closed_eyeblossom": "Stängd ögonblomma",
  "block.minecraft.coal_block": "Kolblock",
  "block.minecraft.coal_ore": "Kolmalm",
  "block.minecraft.coarse_dirt": "Grusig jord",
  "block.minecraft.cobbled_deepslate": "Kullerstensformad djupskiffer",
  "block.minecraft.cobbled_deepslate_slab": "Kullerstensformad djupskifferplatta",
  "block.minecraft.cobbled_deepslate_stairs": "Kullerstensformad djupskiffertrappa",
  "block.minecraft.cobbled_deepslate_wall": "Kullerstensformad djupskiffermur",
  "block.minecraft.cobblestone": "Kullersten",
  "block.minecraft.cobblestone_slab": "Kullerstensplatta",
  "block.minecraft.cobblestone_stairs": "Kullerstenstrappa",
  "block.minecraft.cobblestone_wall": "Kullerstensmur",
  "block.minecraft.cobweb": "Spindelnät",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Kommandoblock",
  "block.minecraft.comparator": "Redstonejämförare",
  "block.minecraft.composter": "Kompost",
  "block.minecraft.conduit": "Flödare",
  "block.minecraft.copper_bars": "Koppargaller",
  "block.minecraft.copper_block": "Kopparblock",
  "block.minecraft.copper_bulb": "Kopparlampa",
  "block.minecraft.copper_chain": "Kopparkedja",
  "block.minecraft.copper_chest": "Kopparkista",
  "block.minecraft.copper_door": "Koppardörr",
  "block.minecraft.copper_golem_statue": "Koppargolemstaty",
  "block.minecraft.copper_grate": "Kopparnät",
  "block.minecraft.copper_lantern": "Kopparlykta",
  "block.minecraft.copper_ore": "Kopparmalm",
  "block.minecraft.copper_torch": "Kopparfackla",
  "block.minecraft.copper_trapdoor": "Kopparfallucka",
  "block.minecraft.copper_wall_torch": "Kopparfackla på vägg",
  "block.minecraft.cornflower": "Blåklint",
  "block.minecraft.cracked_deepslate_bricks": "Sprucken djupskiffermursten",
  "block.minecraft.cracked_deepslate_tiles": "Sprucket djupskiffertegel",
  "block.minecraft.cracked_nether_bricks": "Sprucket nethertegel",
  "block.minecraft.cracked_polished_blackstone_bricks": "Sprucken polerad svartmursten",
  "block.minecraft.cracked_stone_bricks": "Sprucken mursten",
  "block.minecraft.crafter": "Tillverkare",
  "block.minecraft.crafting_table": "Arbetsbänk",
  "block.minecraft.creaking_heart": "Knarrhjärta",
  "block.minecraft.creeper_head": "Creeperhuvud",
  "block.minecraft.creeper_wall_head": "Creeperhuvud på vägg",
  "block.minecraft.crimson_button": "Karmosinknapp",
  "block.minecraft.crimson_door": "Karmosindörr",
  "block.minecraft.crimson_fence": "Karmosinstaket",
  "block.minecraft.crimson_fence_gate": "Karmosingrind",
  "block.minecraft.crimson_fungus": "Karmosinsvamp",
  "block.minecraft.crimson_hanging_sign": "Hängande karmosinskylt",
  "block.minecraft.crimson_hyphae": "Karmosinhyfer",
  "block.minecraft.crimson_nylium": "Karmosinnycel",
  "block.minecraft.crimson_planks": "Karmosinplankor",
  "block.minecraft.crimson_pressure_plate": "Karmosintryckplatta",
  "block.minecraft.crimson_roots": "Karmosinrötter",
  "block.minecraft.crimson_shelf": "Karmosinhylla",
  "block.minecraft.crimson_sign": "Karmosinskylt",
  "block.minecraft.crimson_slab": "Karmosinplatta",
  "block.minecraft.crimson_stairs": "Karmosintrappa",
  "block.minecraft.crimson_stem": "Karmosinstam",
  "block.minecraft.crimson_trapdoor": "Karmosinfallucka",
  "block.minecraft.crimson_wall_hanging_sign": "Hängande karmosinskylt på vägg",
  "block.minecraft.crimson_wall_sign": "Karmosinskylt på vägg",
  "block.minecraft.crying_obsidian": "Gråtande obsidian",
  "block.minecraft.cut_copper": "Skuren koppar",
  "block.minecraft.cut_copper_slab": "Skuren kopparplatta",
  "block.minecraft.cut_copper_stairs": "Skuren koppartrappa",
  "block.minecraft.cut_red_sandstone": "Skuren röd sandsten",
  "block.minecraft.cut_red_sandstone_slab": "Skuren röd sandstensplatta",
  "block.minecraft.cut_sandstone": "Skuren sandsten",
  "block.minecraft.cut_sandstone_slab": "Skuren sandstensplatta",
  "block.minecraft.cyan_banner": "Turkos fana",
  "block.minecraft.cyan_bed": "Turkos säng",
  "block.minecraft.cyan_candle": "Turkost stearinljus",
  "block.minecraft.cyan_candle_cake": "Tårta med turkost stearinljus",
  "block.minecraft.cyan_carpet": "Turkos matta",
  "block.minecraft.cyan_concrete": "Turkos betong",
  "block.minecraft.cyan_concrete_powder": "Turkost betongpulver",
  "block.minecraft.cyan_glazed_terracotta": "Turkosglaserad terrakotta",
  "block.minecraft.cyan_shulker_box": "Turkos shulkerlåda",
  "block.minecraft.cyan_stained_glass": "Turkosfärgat glas",
  "block.minecraft.cyan_stained_glass_pane": "Turkosfärgad glasruta",
  "block.minecraft.cyan_terracotta": "Turkos terrakotta",
  "block.minecraft.cyan_wool": "Turkos ull",
  "block.minecraft.damaged_anvil": "Skadat städ",
  "block.minecraft.dandelion": "Maskros",
  "block.minecraft.dark_oak_button": "Mörk ekknapp",
  "block.minecraft.dark_oak_door": "Mörk ekdörr",
  "block.minecraft.dark_oak_fence": "Mörkt ekstaket",
  "block.minecraft.dark_oak_fence_gate": "Mörk ekgrind",
  "block.minecraft.dark_oak_hanging_sign": "Hängande mörk ekskylt",
  "block.minecraft.dark_oak_leaves": "Mörka eklöv",
  "block.minecraft.dark_oak_log": "Mörk ekstam",
  "block.minecraft.dark_oak_planks": "Mörka ekplankor",
  "block.minecraft.dark_oak_pressure_plate": "Mörk ektryckplatta",
  "block.minecraft.dark_oak_sapling": "Mörk ekplanta",
  "block.minecraft.dark_oak_shelf": "Mörk ekhylla",
  "block.minecraft.dark_oak_sign": "Mörk ekskylt",
  "block.minecraft.dark_oak_slab": "Mörk ekplatta",
  "block.minecraft.dark_oak_stairs": "Mörk ektrappa",
  "block.minecraft.dark_oak_trapdoor": "Mörk ekfallucka",
  "block.minecraft.dark_oak_wall_hanging_sign": "Hängande mörk ekskylt på vägg",
  "block.minecraft.dark_oak_wall_sign": "Mörk ekskylt på vägg",
  "block.minecraft.dark_oak_wood": "Mörkt ekträ",
  "block.minecraft.dark_prismarine": "Mörk prismarin",
  "block.minecraft.dark_prismarine_slab": "Mörk prismarinplatta",
  "block.minecraft.dark_prismarine_stairs": "Mörk prismarintrappa",
  "block.minecraft.daylight_detector": "Dagsljusdetektor",
  "block.minecraft.dead_brain_coral": "Död hjärnkorall",
  "block.minecraft.dead_brain_coral_block": "Dött hjärnkorallblock",
  "block.minecraft.dead_brain_coral_fan": "Död hjärnkorallfläkt",
  "block.minecraft.dead_brain_coral_wall_fan": "Död hjärnkorallfläkt på vägg",
  "block.minecraft.dead_bubble_coral": "Död bubbelkorall",
  "block.minecraft.dead_bubble_coral_block": "Dött bubbelkorallblock",
  "block.minecraft.dead_bubble_coral_fan": "Död bubbelkorallfläkt",
  "block.minecraft.dead_bubble_coral_wall_fan": "Död bubbelkorallfläkt på vägg",
  "block.minecraft.dead_bush": "Död buske",
  "block.minecraft.dead_fire_coral": "Död eldkorall",
  "block.minecraft.dead_fire_coral_block": "Dött eldkorallblock",
  "block.minecraft.dead_fire_coral_fan": "Död eldkorallfläkt",
  "block.minecraft.dead_fire_coral_wall_fan": "Död eldkorallfläkt på vägg",
  "block.minecraft.dead_horn_coral": "Död hornkorall",
  "block.minecraft.dead_horn_coral_block": "Dött hornkorallblock",
  "block.minecraft.dead_horn_coral_fan": "Död hornkorallfläkt",
  "block.minecraft.dead_horn_coral_wall_fan": "Död hornkorallfläkt på vägg",
  "block.minecraft.dead_tube_coral": "Död orgelkorall",
  "block.minecraft.dead_tube_coral_block": "Dött orgelkorallblock",
  "block.minecraft.dead_tube_coral_fan": "Död orgelkorallfläkt",
  "block.minecraft.dead_tube_coral_wall_fan": "Död orgelkorallfläkt på vägg",
  "block.minecraft.decorated_pot": "Dekorerad keramikkruka",
  "block.minecraft.deepslate": "Djupskiffer",
  "block.minecraft.deepslate_brick_slab": "Djupskiffermurstensplatta",
  "block.minecraft.deepslate_brick_stairs": "Djupskiffermurstenstrappa",
  "block.minecraft.deepslate_brick_wall": "Djupskiffermurstensmur",
  "block.minecraft.deepslate_bricks": "Djupskiffermursten",
  "block.minecraft.deepslate_coal_ore": "Djupskifferinbäddad kolmalm",
  "block.minecraft.deepslate_copper_ore": "Djupskifferinbäddad kopparmalm",
  "block.minecraft.deepslate_diamond_ore": "Djupskifferinbäddad diamantmalm",
  "block.minecraft.deepslate_emerald_ore": "Djupskifferinbäddad smaragdmalm",
  "block.minecraft.deepslate_gold_ore": "Djupskifferinbäddad guldmalm",
  "block.minecraft.deepslate_iron_ore": "Djupskifferinbäddad järnmalm",
  "block.minecraft.deepslate_lapis_ore": "Djupskifferinbäddad lapis lazulimalm",
  "block.minecraft.deepslate_redstone_ore": "Djupskifferinbäddad redstonemalm",
  "block.minecraft.deepslate_tile_slab": "Djupskiffertegelplatta",
  "block.minecraft.deepslate_tile_stairs": "Djupskiffertegeltrappa",
  "block.minecraft.deepslate_tile_wall": "Djupskiffertegelmur",
  "block.minecraft.deepslate_tiles": "Djupskiffertegel",
  "block.minecraft.detector_rail": "Sensorräls",
  "block.minecraft.diamond_block": "Diamantblock",
  "block.minecraft.diamond_ore": "Diamantmalm",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritplatta",
  "block.minecraft.diorite_stairs": "Diorittrappa",
  "block.minecraft.diorite_wall": "Dioritmur",
  "block.minecraft.dirt": "Jord",
  "block.minecraft.dirt_path": "Jordstig",
  "block.minecraft.dispenser": "Automat",
  "block.minecraft.dragon_egg": "Drakägg",
  "block.minecraft.dragon_head": "Drakhuvud",
  "block.minecraft.dragon_wall_head": "Drakhuvud på vägg",
  "block.minecraft.dried_ghast": "Uttorkad ghast",
  "block.minecraft.dried_kelp_block": "Torkat kelpblock",
  "block.minecraft.dripstone_block": "Droppstensblock",
  "block.minecraft.dropper": "Utmatare",
  "block.minecraft.emerald_block": "Smaragdblock",
  "block.minecraft.emerald_ore": "Smaragdmalm",
  "block.minecraft.enchanting_table": "Förtrollningsbord",
  "block.minecraft.end_gateway": "Endpassage",
  "block.minecraft.end_portal": "Endportal",
  "block.minecraft.end_portal_frame": "Endportalsram",
  "block.minecraft.end_rod": "Endstav",
  "block.minecraft.end_stone": "Endsten",
  "block.minecraft.end_stone_brick_slab": "Endmurstensplatta",
  "block.minecraft.end_stone_brick_stairs": "Endmurstenstrappa",
  "block.minecraft.end_stone_brick_wall": "Endmurstensmur",
  "block.minecraft.end_stone_bricks": "Endmursten",
  "block.minecraft.ender_chest": "Enderkista",
  "block.minecraft.exposed_chiseled_copper": "Exponerad mejslad koppar",
  "block.minecraft.exposed_copper": "Exponerad koppar",
  "block.minecraft.exposed_copper_bars": "Exponerat koppargaller",
  "block.minecraft.exposed_copper_bulb": "Exponerad kopparlampa",
  "block.minecraft.exposed_copper_chain": "Exponerad kopparkedja",
  "block.minecraft.exposed_copper_chest": "Exponerad kopparkista",
  "block.minecraft.exposed_copper_door": "Exponerad koppardörr",
  "block.minecraft.exposed_copper_golem_statue": "Exponerad koppargolemstaty",
  "block.minecraft.exposed_copper_grate": "Exponerat kopparnät",
  "block.minecraft.exposed_copper_lantern": "Exponerad kopparlykta",
  "block.minecraft.exposed_copper_trapdoor": "Exponerad kopparfallucka",
  "block.minecraft.exposed_cut_copper": "Exponerad skuren koppar",
  "block.minecraft.exposed_cut_copper_slab": "Exponerad skuren kopparplatta",
  "block.minecraft.exposed_cut_copper_stairs": "Exponerad skuren koppartrappa",
  "block.minecraft.exposed_lightning_rod": "Exponerad åskledare",
  "block.minecraft.farmland": "Åkerjord",
  "block.minecraft.fern": "Ormbunke",
  "block.minecraft.fire": "Eld",
  "block.minecraft.fire_coral": "Eldkorall",
  "block.minecraft.fire_coral_block": "Eldkorallblock",
  "block.minecraft.fire_coral_fan": "Eldkorallfläkt",
  "block.minecraft.fire_coral_wall_fan": "Eldkorallfläkt på vägg",
  "block.minecraft.firefly_bush": "Eldflugsbuske",
  "block.minecraft.fletching_table": "Pilmakarbänk",
  "block.minecraft.flower_pot": "Blomkruka",
  "block.minecraft.flowering_azalea": "Blommande azalea",
  "block.minecraft.flowering_azalea_leaves": "Blommande azalealöv",
  "block.minecraft.frogspawn": "Grodrom",
  "block.minecraft.frosted_ice": "Frostad is",
  "block.minecraft.furnace": "Ugn",
  "block.minecraft.gilded_blackstone": "Förgylld svartsten",
  "block.minecraft.glass": "Glas",
  "block.minecraft.glass_pane": "Glasruta",
  "block.minecraft.glow_lichen": "Självlysande lav",
  "block.minecraft.glowstone": "Glödsten",
  "block.minecraft.gold_block": "Guldblock",
  "block.minecraft.gold_ore": "Guldmalm",
  "block.minecraft.golden_dandelion": "Gyllene maskros",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitplatta",
  "block.minecraft.granite_stairs": "Granittrappa",
  "block.minecraft.granite_wall": "Granitmur",
  "block.minecraft.grass": "Gräs",
  "block.minecraft.grass_block": "Gräsblock",
  "block.minecraft.gravel": "Grus",
  "block.minecraft.gray_banner": "Grå fana",
  "block.minecraft.gray_bed": "Grå säng",
  "block.minecraft.gray_candle": "Grått stearinljus",
  "block.minecraft.gray_candle_cake": "Tårta med grått stearinljus",
  "block.minecraft.gray_carpet": "Grå matta",
  "block.minecraft.gray_concrete": "Grå betong",
  "block.minecraft.gray_concrete_powder": "Grått betongpulver",
  "block.minecraft.gray_glazed_terracotta": "Gråglaserad terrakotta",
  "block.minecraft.gray_shulker_box": "Grå shulkerlåda",
  "block.minecraft.gray_stained_glass": "Gråfärgat glas",
  "block.minecraft.gray_stained_glass_pane": "Gråfärgad glasruta",
  "block.minecraft.gray_terracotta": "Grå terrakotta",
  "block.minecraft.gray_wool": "Grå ull",
  "block.minecraft.green_banner": "Grön fana",
  "block.minecraft.green_bed": "Grön säng",
  "block.minecraft.green_candle": "Grönt stearinljus",
  "block.minecraft.green_candle_cake": "Tårta med grönt stearinljus",
  "block.minecraft.green_carpet": "Grön matta",
  "block.minecraft.green_concrete": "Grön betong",
  "block.minecraft.green_concrete_powder": "Grönt betongpulver",
  "block.minecraft.green_glazed_terracotta": "Grönglaserad terrakotta",
  "block.minecraft.green_shulker_box": "Grön shulkerlåda",
  "block.minecraft.green_stained_glass": "Grönfärgat glas",
  "block.minecraft.green_stained_glass_pane": "Grönfärgad glasruta",
  "block.minecraft.green_terracotta": "Grön terrakotta",
  "block.minecraft.green_wool": "Grön ull",
  "block.minecraft.grindstone": "Slipsten",
  "block.minecraft.hanging_roots": "Hängande rötter",
  "block.minecraft.hay_block": "Höbal",
  "block.minecraft.heavy_core": "Tung kärna",
  "block.minecraft.heavy_weighted_pressure_plate": "Tung tyngdtryckplatta",
  "block.minecraft.honey_block": "Honungsblock",
  "block.minecraft.honeycomb_block": "Vaxkaksblock",
  "block.minecraft.hopper": "Tratt",
  "block.minecraft.horn_coral": "Hornkorall",
  "block.minecraft.horn_coral_block": "Hornkorallblock",
  "block.minecraft.horn_coral_fan": "Hornkorallfläkt",
  "block.minecraft.horn_coral_wall_fan": "Hornkorallfläkt på vägg",
  "block.minecraft.ice": "Is",
  "block.minecraft.infested_chiseled_stone_bricks": "Angripen mejslad mursten",
  "block.minecraft.infested_cobblestone": "Angripen kullersten",
  "block.minecraft.infested_cracked_stone_bricks": "Angripen sprucken mursten",
  "block.minecraft.infested_deepslate": "Angripen djupskiffer",
  "block.minecraft.infested_mossy_stone_bricks": "Angripen mossig mursten",
  "block.minecraft.infested_stone": "Angripen sten",
  "block.minecraft.infested_stone_bricks": "Angripen mursten",
  "block.minecraft.iron_bars": "Järngaller",
  "block.minecraft.iron_block": "Järnblock",
  "block.minecraft.iron_chain": "Järnkedja",
  "block.minecraft.iron_door": "Järndörr",
  "block.minecraft.iron_ore": "Järnmalm",
  "block.minecraft.iron_trapdoor": "Järnfallucka",
  "block.minecraft.jack_o_lantern": "Pumpalykta",
  "block.minecraft.jigsaw": "Pusselbitsblock",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Djungelknapp",
  "block.minecraft.jungle_door": "Djungeldörr",
  "block.minecraft.jungle_fence": "Djungelstaket",
  "block.minecraft.jungle_fence_gate": "Djungelgrind",
  "block.minecraft.jungle_hanging_sign": "Hängande djungelskylt",
  "block.minecraft.jungle_leaves": "Djungellöv",
  "block.minecraft.jungle_log": "Djungelträdstam",
  "block.minecraft.jungle_planks": "Djungelplankor",
  "block.minecraft.jungle_pressure_plate": "Djungeltryckplatta",
  "block.minecraft.jungle_sapling": "Djungelplanta",
  "block.minecraft.jungle_shelf": "Djungelhylla",
  "block.minecraft.jungle_sign": "Djungelskylt",
  "block.minecraft.jungle_slab": "Djungelplatta",
  "block.minecraft.jungle_stairs": "Djungeltrappa",
  "block.minecraft.jungle_trapdoor": "Djungelfallucka",
  "block.minecraft.jungle_wall_hanging_sign": "Hängande djungelskylt på vägg",
  "block.minecraft.jungle_wall_sign": "Djungelskylt på vägg",
  "block.minecraft.jungle_wood": "Djungelträ",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelpplanta",
  "block.minecraft.ladder": "Stege",
  "block.minecraft.lantern": "Lykta",
  "block.minecraft.lapis_block": "Lapis lazuliblock",
  "block.minecraft.lapis_ore": "Lapis lazulimalm",
  "block.minecraft.large_amethyst_bud": "Stor ametistknopp",
  "block.minecraft.large_fern": "Stor ormbunke",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavakittel",
  "block.minecraft.leaf_litter": "Lövrester",
  "block.minecraft.lectern": "Läspulpet",
  "block.minecraft.lever": "Spak",
  "block.minecraft.light": "Ljus",
  "block.minecraft.light_blue_banner": "Ljusblå fana",
  "block.minecraft.light_blue_bed": "Ljusblå säng",
  "block.minecraft.light_blue_candle": "Ljusblått stearinljus",
  "block.minecraft.light_blue_candle_cake": "Tårta med ljusblått stearinljus",
  "block.minecraft.light_blue_carpet": "Ljusblå matta",
  "block.minecraft.light_blue_concrete": "Ljusblå betong",
  "block.minecraft.light_blue_concrete_powder": "Ljusblått betongpulver",
  "block.minecraft.light_blue_glazed_terracotta": "Ljusblåglaserad terrakotta",
  "block.minecraft.light_blue_shulker_box": "Ljusblå shulkerlåda",
  "block.minecraft.light_blue_stained_glass": "Ljusblåfärgat glas",
  "block.minecraft.light_blue_stained_glass_pane": "Ljusblåfärgad glasruta",
  "block.minecraft.light_blue_terracotta": "Ljusblå terrakotta",
  "block.minecraft.light_blue_wool": "Ljusblå ull",
  "block.minecraft.light_gray_banner": "Ljusgrå fana",
  "block.minecraft.light_gray_bed": "Ljusgrå säng",
  "block.minecraft.light_gray_candle": "Ljusgrått stearinljus",
  "block.minecraft.light_gray_candle_cake": "Tårta med ljusgrått stearinljus",
  "block.minecraft.light_gray_carpet": "Ljusgrå matta",
  "block.minecraft.light_gray_concrete": "Ljusgrå betong",
  "block.minecraft.light_gray_concrete_powder": "Ljusgrått betongpulver",
  "block.minecraft.light_gray_glazed_terracotta": "Ljusgråglaserad terrakotta",
  "block.minecraft.light_gray_shulker_box": "Ljusgrå shulkerlåda",
  "block.minecraft.light_gray_stained_glass": "Ljusgråfärgat glas",
  "block.minecraft.light_gray_stained_glass_pane": "Ljusgråfärgad glasruta",
  "block.minecraft.light_gray_terracotta": "Ljusgrå terrakotta",
  "block.minecraft.light_gray_wool": "Ljusgrå ull",
  "block.minecraft.light_weighted_pressure_plate": "Lätt tyngdtryckplatta",
  "block.minecraft.lightning_rod": "Åskledare",
  "block.minecraft.lilac": "Syren",
  "block.minecraft.lily_of_the_valley": "Liljekonvalj",
  "block.minecraft.lily_pad": "Näckrosblad",
  "block.minecraft.lime_banner": "Limegrön fana",
  "block.minecraft.lime_bed": "Limegrön säng",
  "block.minecraft.lime_candle": "Limegrönt stearinljus",
  "block.minecraft.lime_candle_cake": "Tårta med limegrönt stearinljus",
  "block.minecraft.lime_carpet": "Limegrön matta",
  "block.minecraft.lime_concrete": "Limegrön betong",
  "block.minecraft.lime_concrete_powder": "Limegrönt betongpulver",
  "block.minecraft.lime_glazed_terracotta": "Limegrönglaserad terrakotta",
  "block.minecraft.lime_shulker_box": "Limegrön shulkerlåda",
  "block.minecraft.lime_stained_glass": "Limegrönfärgat glas",
  "block.minecraft.lime_stained_glass_pane": "Limegrönfärgad glasruta",
  "block.minecraft.lime_terracotta": "Limegrön terrakotta",
  "block.minecraft.lime_wool": "Limegrön ull",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Vävstol",
  "block.minecraft.magenta_banner": "Ljuslila fana",
  "block.minecraft.magenta_bed": "Ljuslila säng",
  "block.minecraft.magenta_candle": "Ljuslila stearinljus",
  "block.minecraft.magenta_candle_cake": "Tårta med ljuslila stearinljus",
  "block.minecraft.magenta_carpet": "Ljuslila matta",
  "block.minecraft.magenta_concrete": "Ljuslila betong",
  "block.minecraft.magenta_concrete_powder": "Ljuslila betongpulver",
  "block.minecraft.magenta_glazed_terracotta": "Ljuslilaglaserad terrakotta",
  "block.minecraft.magenta_shulker_box": "Ljuslila shulkerlåda",
  "block.minecraft.magenta_stained_glass": "Ljuslilafärgat glas",
  "block.minecraft.magenta_stained_glass_pane": "Ljuslilafärgad glasruta",
  "block.minecraft.magenta_terracotta": "Ljuslila terrakotta",
  "block.minecraft.magenta_wool": "Ljuslila ull",
  "block.minecraft.magma_block": "Magmablock",
  "block.minecraft.mangrove_button": "Mangroveknapp",
  "block.minecraft.mangrove_door": "Mangrovedörr",
  "block.minecraft.mangrove_fence": "Mangrovestaket",
  "block.minecraft.mangrove_fence_gate": "Mangrovegrind",
  "block.minecraft.mangrove_hanging_sign": "Hängande mangroveskylt",
  "block.minecraft.mangrove_leaves": "Mangrovelöv",
  "block.minecraft.mangrove_log": "Mangrovestam",
  "block.minecraft.mangrove_planks": "Mangroveplankor",
  "block.minecraft.mangrove_pressure_plate": "Mangrovetryckplatta",
  "block.minecraft.mangrove_propagule": "Mangroveskott",
  "block.minecraft.mangrove_roots": "Mangroverötter",
  "block.minecraft.mangrove_shelf": "Mangrovehylla",
  "block.minecraft.mangrove_sign": "Mangroveskylt",
  "block.minecraft.mangrove_slab": "Mangroveplatta",
  "block.minecraft.mangrove_stairs": "Mangrovetrappa",
  "block.minecraft.mangrove_trapdoor": "Mangrovefallucka",
  "block.minecraft.mangrove_wall_hanging_sign": "Hängande mangroveskylt på vägg",
  "block.minecraft.mangrove_wall_sign": "Mangroveskylt på vägg",
  "block.minecraft.mangrove_wood": "Mangroveträ",
  "block.minecraft.medium_amethyst_bud": "Medelstor ametistknopp",
  "block.minecraft.melon": "Melon",
  "block.minecraft.melon_stem": "Melonstjälk",
  "block.minecraft.moss_block": "Mossblock",
  "block.minecraft.moss_carpet": "Mossmatta",
  "block.minecraft.mossy_cobblestone": "Mossig kullersten",
  "block.minecraft.mossy_cobblestone_slab": "Mossig kullerstensplatta",
  "block.minecraft.mossy_cobblestone_stairs": "Mossig kullerstenstrappa",
  "block.minecraft.mossy_cobblestone_wall": "Mossig kullerstensmur",
  "block.minecraft.mossy_stone_brick_slab": "Mossig murstensplatta",
  "block.minecraft.mossy_stone_brick_stairs": "Mossig murstenstrappa",
  "block.minecraft.mossy_stone_brick_wall": "Mossig murstensmur",
  "block.minecraft.mossy_stone_bricks": "Mossig mursten",
  "block.minecraft.moving_piston": "Kolv i rörelse",
  "block.minecraft.mud": "Gyttja",
  "block.minecraft.mud_brick_slab": "Gyttjemurstensplatta",
  "block.minecraft.mud_brick_stairs": "Gyttjemurstenstrappa",
  "block.minecraft.mud_brick_wall": "Gyttjemurstensmur",
  "block.minecraft.mud_bricks": "Gyttjemursten",
  "block.minecraft.muddy_mangrove_roots": "Gyttjiga mangroverötter",
  "block.minecraft.mushroom_stem": "Svampfot",
  "block.minecraft.mycelium": "Mycel",
  "block.minecraft.nether_brick_fence": "Nethertegelstaket",
  "block.minecraft.nether_brick_slab": "Nethertegelplatta",
  "block.minecraft.nether_brick_stairs": "Nethertegeltrappa",
  "block.minecraft.nether_brick_wall": "Nethertegelmur",
  "block.minecraft.nether_bricks": "Nethertegel",
  "block.minecraft.nether_gold_ore": "Netherguldmalm",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherkvartsmalm",
  "block.minecraft.nether_sprouts": "Netherskott",
  "block.minecraft.nether_wart": "Nethervårta",
  "block.minecraft.nether_wart_block": "Nethervårtsblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Notblock",
  "block.minecraft.oak_button": "Ekknapp",
  "block.minecraft.oak_door": "Ekdörr",
  "block.minecraft.oak_fence": "Ekstaket",
  "block.minecraft.oak_fence_gate": "Ekgrind",
  "block.minecraft.oak_hanging_sign": "Hängande ekskylt",
  "block.minecraft.oak_leaves": "Eklöv",
  "block.minecraft.oak_log": "Ekstam",
  "block.minecraft.oak_planks": "Ekplankor",
  "block.minecraft.oak_pressure_plate": "Ektryckplatta",
  "block.minecraft.oak_sapling": "Ekplanta",
  "block.minecraft.oak_shelf": "Ekhylla",
  "block.minecraft.oak_sign": "Ekskylt",
  "block.minecraft.oak_slab": "Ekplatta",
  "block.minecraft.oak_stairs": "Ektrappa",
  "block.minecraft.oak_trapdoor": "Ekfallucka",
  "block.minecraft.oak_wall_hanging_sign": "Hängande ekskylt på vägg",
  "block.minecraft.oak_wall_sign": "Ekskylt på vägg",
  "block.minecraft.oak_wood": "Ekträ",
  "block.minecraft.observer": "Observatör",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ockraskinande grodljus",
  "block.minecraft.ominous_banner": "Oroväckande fana",
  "block.minecraft.open_eyeblossom": "Öppen ögonblomma",
  "block.minecraft.orange_banner": "Orange fana",
  "block.minecraft.orange_bed": "Orange säng",
  "block.minecraft.orange_candle": "Orange stearinljus",
  "block.minecraft.orange_candle_cake": "Tårta med orange stearinljus",
  "block.minecraft.orange_carpet": "Orange matta",
  "block.minecraft.orange_concrete": "Orange betong",
  "block.minecraft.orange_concrete_powder": "Orange betongpulver",
  "block.minecraft.orange_glazed_terracotta": "Orangeglaserad terrakotta",
  "block.minecraft.orange_shulker_box": "Orange shulkerlåda",
  "block.minecraft.orange_stained_glass": "Orangefärgat glas",
  "block.minecraft.orange_stained_glass_pane": "Orangefärgad glasruta",
  "block.minecraft.orange_terracotta": "Orange terrakotta",
  "block.minecraft.orange_tulip": "Orange tulpan",
  "block.minecraft.orange_wool": "Orange ull",
  "block.minecraft.oxeye_daisy": "Prästkrage",
  "block.minecraft.oxidized_chiseled_copper": "Ärgad mejslad koppar",
  "block.minecraft.oxidized_copper": "Ärgad koppar",
  "block.minecraft.oxidized_copper_bars": "Ärgat koppargaller",
  "block.minecraft.oxidized_copper_bulb": "Ärgad kopparlampa",
  "block.minecraft.oxidized_copper_chain": "Ärgad kopparkedja",
  "block.minecraft.oxidized_copper_chest": "Ärgad kopparkista",
  "block.minecraft.oxidized_copper_door": "Ärgad koppardörr",
  "block.minecraft.oxidized_copper_golem_statue": "Ärgad koppargolemstaty",
  "block.minecraft.oxidized_copper_grate": "Ärgat kopparnät",
  "block.minecraft.oxidized_copper_lantern": "Ärgad kopparlykta",
  "block.minecraft.oxidized_copper_trapdoor": "Ärgad kopparfallucka",
  "block.minecraft.oxidized_cut_copper": "Ärgad skuren koppar",
  "block.minecraft.oxidized_cut_copper_slab": "Ärgad skuren kopparplatta",
  "block.minecraft.oxidized_cut_copper_stairs": "Ärgad skuren koppartrappa",
  "block.minecraft.oxidized_lightning_rod": "Ärgad åskledare",
  "block.minecraft.packed_ice": "Packad is",
  "block.minecraft.packed_mud": "Packad gyttja",
  "block.minecraft.pale_hanging_moss": "Hängande blek mossa",
  "block.minecraft.pale_moss_block": "Blekt mossblock",
  "block.minecraft.pale_moss_carpet": "Blek mossmatta",
  "block.minecraft.pale_oak_button": "Blek ekknapp",
  "block.minecraft.pale_oak_door": "Blek ekdörr",
  "block.minecraft.pale_oak_fence": "Blekt ekstaket",
  "block.minecraft.pale_oak_fence_gate": "Blek ekgrind",
  "block.minecraft.pale_oak_hanging_sign": "Hängande blek ekskylt",
  "block.minecraft.pale_oak_leaves": "Bleka eklöv",
  "block.minecraft.pale_oak_log": "Blek ekstam",
  "block.minecraft.pale_oak_planks": "Bleka ekplankor",
  "block.minecraft.pale_oak_pressure_plate": "Blek ektryckplatta",
  "block.minecraft.pale_oak_sapling": "Blek ekplanta",
  "block.minecraft.pale_oak_shelf": "Blek ekhylla",
  "block.minecraft.pale_oak_sign": "Blek ekskylt",
  "block.minecraft.pale_oak_slab": "Blek ekplatta",
  "block.minecraft.pale_oak_stairs": "Blek ektrappa",
  "block.minecraft.pale_oak_trapdoor": "Blek ekfallucka",
  "block.minecraft.pale_oak_wall_hanging_sign": "Hängande blek ekskylt på vägg",
  "block.minecraft.pale_oak_wall_sign": "Blek ekskylt på vägg",
  "block.minecraft.pale_oak_wood": "Blekt ekträ",
  "block.minecraft.pearlescent_froglight": "Pärlemorskimrande grodljus",
  "block.minecraft.peony": "Pion",
  "block.minecraft.petrified_oak_slab": "Förstenad ekplatta",
  "block.minecraft.piglin_head": "Piglinhuvud",
  "block.minecraft.piglin_wall_head": "Piglinhuvud på vägg",
  "block.minecraft.pink_banner": "Rosa fana",
  "block.minecraft.pink_bed": "Rosa säng",
  "block.minecraft.pink_candle": "Rosa stearinljus",
  "block.minecraft.pink_candle_cake": "Tårta med rosa stearinljus",
  "block.minecraft.pink_carpet": "Rosa matta",
  "block.minecraft.pink_concrete": "Rosa betong",
  "block.minecraft.pink_concrete_powder": "Rosa betongpulver",
  "block.minecraft.pink_glazed_terracotta": "Rosaglaserad terrakotta",
  "block.minecraft.pink_petals": "Rosa kronblad",
  "block.minecraft.pink_shulker_box": "Rosa shulkerlåda",
  "block.minecraft.pink_stained_glass": "Rosafärgat glas",
  "block.minecraft.pink_stained_glass_pane": "Rosafärgad glasruta",
  "block.minecraft.pink_terracotta": "Rosa terrakotta",
  "block.minecraft.pink_tulip": "Rosa tulpan",
  "block.minecraft.pink_wool": "Rosa ull",
  "block.minecraft.piston": "Kolv",
  "block.minecraft.piston_head": "Kolvhuvud",
  "block.minecraft.pitcher_crop": "Kannrankeplanta",
  "block.minecraft.pitcher_plant": "Kannranka",
  "block.minecraft.player_head": "Spelarhuvud",
  "block.minecraft.player_head.named": "%ss huvud",
  "block.minecraft.player_wall_head": "Spelarhuvud på vägg",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spetsig droppsten",
  "block.minecraft.polished_andesite": "Polerad andesit",
  "block.minecraft.polished_andesite_slab": "Polerad andesitplatta",
  "block.minecraft.polished_andesite_stairs": "Polerad andesittrappa",
  "block.minecraft.polished_basalt": "Polerad basalt",
  "block.minecraft.polished_blackstone": "Polerad svartsten",
  "block.minecraft.polished_blackstone_brick_slab": "Polerad svartmurstensplatta",
  "block.minecraft.polished_blackstone_brick_stairs": "Polerad svartmurstenstrappa",
  "block.minecraft.polished_blackstone_brick_wall": "Polerad svartmurstensmur",
  "block.minecraft.polished_blackstone_bricks": "Polerad svartmursten",
  "block.minecraft.polished_blackstone_button": "Polerad svartstensknapp",
  "block.minecraft.polished_blackstone_pressure_plate": "Polerad svartstenstryckplatta",
  "block.minecraft.polished_blackstone_slab": "Polerad svartstensplatta",
  "block.minecraft.polished_blackstone_stairs": "Polerad svartstenstrappa",
  "block.minecraft.polished_blackstone_wall": "Polerad svartstensmur",
  "block.minecraft.polished_deepslate": "Polerad djupskiffer",
  "block.minecraft.polished_deepslate_slab": "Polerad djupskifferplatta",
  "block.minecraft.polished_deepslate_stairs": "Polerad djupskiffertrappa",
  "block.minecraft.polished_deepslate_wall": "Polerad djupskiffermur",
  "block.minecraft.polished_diorite": "Polerad diorit",
  "block.minecraft.polished_diorite_slab": "Polerad dioritplatta",
  "block.minecraft.polished_diorite_stairs": "Polerad diorittrappa",
  "block.minecraft.polished_granite": "Polerad granit",
  "block.minecraft.polished_granite_slab": "Polerad granitplatta",
  "block.minecraft.polished_granite_stairs": "Polerad granittrappa",
  "block.minecraft.polished_tuff": "Polerad tuff",
  "block.minecraft.polished_tuff_slab": "Polerad tuffplatta",
  "block.minecraft.polished_tuff_stairs": "Polerad tufftrappa",
  "block.minecraft.polished_tuff_wall": "Polerad tuffmur",
  "block.minecraft.poppy": "Vallmo",
  "block.minecraft.potatoes": "Potatisar",
  "block.minecraft.potted_acacia_sapling": "Akaciaplanta i kruka",
  "block.minecraft.potted_allium": "Gräslök i kruka",
  "block.minecraft.potted_azalea_bush": "Azalea i kruka",
  "block.minecraft.potted_azure_bluet": "Porslinsstjärna i kruka",
  "block.minecraft.potted_bamboo": "Bambu i kruka",
  "block.minecraft.potted_birch_sapling": "Björkplanta i kruka",
  "block.minecraft.potted_blue_orchid": "Blå orkidé i kruka",
  "block.minecraft.potted_brown_mushroom": "Brun svamp i kruka",
  "block.minecraft.potted_cactus": "Kaktus i kruka",
  "block.minecraft.potted_cherry_sapling": "Körsbärsplanta i kruka",
  "block.minecraft.potted_closed_eyeblossom": "Stängd ögonblomma i kruka",
  "block.minecraft.potted_cornflower": "Blåklint i kruka",
  "block.minecraft.potted_crimson_fungus": "Karmosinsvamp i kruka",
  "block.minecraft.potted_crimson_roots": "Karmosinrötter i kruka",
  "block.minecraft.potted_dandelion": "Maskros i kruka",
  "block.minecraft.potted_dark_oak_sapling": "Mörk ekplanta i kruka",
  "block.minecraft.potted_dead_bush": "Död buske i kruka",
  "block.minecraft.potted_fern": "Ormbunke i kruka",
  "block.minecraft.potted_flowering_azalea_bush": "Blommande azalea i kruka",
  "block.minecraft.potted_golden_dandelion": "Gyllene maskros i kruka",
  "block.minecraft.potted_jungle_sapling": "Djungelplanta i kruka",
  "block.minecraft.potted_lily_of_the_valley": "Liljekonvalj i kruka",
  "block.minecraft.potted_mangrove_propagule": "Mangroveskott i kruka",
  "block.minecraft.potted_oak_sapling": "Ekplanta i kruka",
  "block.minecraft.potted_open_eyeblossom": "Öppen ögonblomma i kruka",
  "block.minecraft.potted_orange_tulip": "Orange tulpan i kruka",
  "block.minecraft.potted_oxeye_daisy": "Prästkrage i kruka",
  "block.minecraft.potted_pale_oak_sapling": "Blek ekplanta i kruka",
  "block.minecraft.potted_pink_tulip": "Rosa tulpan i kruka",
  "block.minecraft.potted_poppy": "Vallmo i kruka",
  "block.minecraft.potted_red_mushroom": "Röd svamp i kruka",
  "block.minecraft.potted_red_tulip": "Röd tulpan i kruka",
  "block.minecraft.potted_spruce_sapling": "Granplanta i kruka",
  "block.minecraft.potted_torchflower": "Fackellilja i kruka",
  "block.minecraft.potted_warped_fungus": "Förvrängd svamp i kruka",
  "block.minecraft.potted_warped_roots": "Förvrängda rötter i kruka",
  "block.minecraft.potted_white_tulip": "Vit tulpan i kruka",
  "block.minecraft.potted_wither_rose": "Witherros i kruka",
  "block.minecraft.powder_snow": "Pudersnö",
  "block.minecraft.powder_snow_cauldron": "Pudersnökittel",
  "block.minecraft.powered_rail": "Krafträls",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinmurstensplatta",
  "block.minecraft.prismarine_brick_stairs": "Prismarinmurstenstrappa",
  "block.minecraft.prismarine_bricks": "Prismarinmursten",
  "block.minecraft.prismarine_slab": "Prismarinplatta",
  "block.minecraft.prismarine_stairs": "Prismarintrappa",
  "block.minecraft.prismarine_wall": "Prismarinmur",
  "block.minecraft.pumpkin": "Pumpa",
  "block.minecraft.pumpkin_stem": "Pumpastjälk",
  "block.minecraft.purple_banner": "Lila fana",
  "block.minecraft.purple_bed": "Lila säng",
  "block.minecraft.purple_candle": "Lila stearinljus",
  "block.minecraft.purple_candle_cake": "Tårta med lila stearinljus",
  "block.minecraft.purple_carpet": "Lila matta",
  "block.minecraft.purple_concrete": "Lila betong",
  "block.minecraft.purple_concrete_powder": "Lila betongpulver",
  "block.minecraft.purple_glazed_terracotta": "Lilaglaserad terrakotta",
  "block.minecraft.purple_shulker_box": "Lila shulkerlåda",
  "block.minecraft.purple_stained_glass": "Lilafärgat glas",
  "block.minecraft.purple_stained_glass_pane": "Lilafärgad glasruta",
  "block.minecraft.purple_terracotta": "Lila terrakotta",
  "block.minecraft.purple_wool": "Lila ull",
  "block.minecraft.purpur_block": "Purpurblock",
  "block.minecraft.purpur_pillar": "Purpurpelare",
  "block.minecraft.purpur_slab": "Purpurplatta",
  "block.minecraft.purpur_stairs": "Purpurtrappa",
  "block.minecraft.quartz_block": "Kvartsblock",
  "block.minecraft.quartz_bricks": "Kvartsmursten",
  "block.minecraft.quartz_pillar": "Kvartspelare",
  "block.minecraft.quartz_slab": "Kvartsplatta",
  "block.minecraft.quartz_stairs": "Kvartstrappa",
  "block.minecraft.rail": "Räls",
  "block.minecraft.raw_copper_block": "Råkopparblock",
  "block.minecraft.raw_gold_block": "Råguldsblock",
  "block.minecraft.raw_iron_block": "Råjärnsblock",
  "block.minecraft.red_banner": "Röd fana",
  "block.minecraft.red_bed": "Röd säng",
  "block.minecraft.red_candle": "Rött stearinljus",
  "block.minecraft.red_candle_cake": "Tårta med rött stearinljus",
  "block.minecraft.red_carpet": "Röd matta",
  "block.minecraft.red_concrete": "Röd betong",
  "block.minecraft.red_concrete_powder": "Rött betongpulver",
  "block.minecraft.red_glazed_terracotta": "Rödglaserad terrakotta",
  "block.minecraft.red_mushroom": "Röd svamp",
  "block.minecraft.red_mushroom_block": "Rött svampblock",
  "block.minecraft.red_nether_brick_slab": "Röd nethertegelplatta",
  "block.minecraft.red_nether_brick_stairs": "Röd nethertegeltrappa",
  "block.minecraft.red_nether_brick_wall": "Röd nethertegelmur",
  "block.minecraft.red_nether_bricks": "Rött nethertegel",
  "block.minecraft.red_sand": "Röd sand",
  "block.minecraft.red_sandstone": "Röd sandsten",
  "block.minecraft.red_sandstone_slab": "Röd sandstensplatta",
  "block.minecraft.red_sandstone_stairs": "Röd sandstenstrappa",
  "block.minecraft.red_sandstone_wall": "Röd sandstensmur",
  "block.minecraft.red_shulker_box": "Röd shulkerlåda",
  "block.minecraft.red_stained_glass": "Rödfärgat glas",
  "block.minecraft.red_stained_glass_pane": "Rödfärgad glasruta",
  "block.minecraft.red_terracotta": "Röd terrakotta",
  "block.minecraft.red_tulip": "Röd tulpan",
  "block.minecraft.red_wool": "Röd ull",
  "block.minecraft.redstone_block": "Redstoneblock",
  "block.minecraft.redstone_lamp": "Redstonelampa",
  "block.minecraft.redstone_ore": "Redstonemalm",
  "block.minecraft.redstone_torch": "Redstonefackla",
  "block.minecraft.redstone_wall_torch": "Redstonefackla på vägg",
  "block.minecraft.redstone_wire": "Redstonetråd",
  "block.minecraft.reinforced_deepslate": "Förstärkt djupskiffer",
  "block.minecraft.repeater": "Redstonerepeterare",
  "block.minecraft.repeating_command_block": "Upprepande kommandoblock",
  "block.minecraft.resin_block": "Hartsblock",
  "block.minecraft.resin_brick_slab": "Hartstegelplatta",
  "block.minecraft.resin_brick_stairs": "Hartstegeltrappa",
  "block.minecraft.resin_brick_wall": "Hartstegelmur",
  "block.minecraft.resin_bricks": "Hartstegel",
  "block.minecraft.resin_clump": "Hartsklump",
  "block.minecraft.respawn_anchor": "Återuppståndelseankare",
  "block.minecraft.rooted_dirt": "Rotad jord",
  "block.minecraft.rose_bush": "Rosbuske",
  "block.minecraft.sand": "Sand",
  "block.minecraft.sandstone": "Sandsten",
  "block.minecraft.sandstone_slab": "Sandstensplatta",
  "block.minecraft.sandstone_stairs": "Sandstenstrappa",
  "block.minecraft.sandstone_wall": "Sandstensmur",
  "block.minecraft.scaffolding": "Byggnadsställning",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculkkatalysator",
  "block.minecraft.sculk_sensor": "Sculksensor",
  "block.minecraft.sculk_shrieker": "Sculkskrikare",
  "block.minecraft.sculk_vein": "Sculkven",
  "block.minecraft.sea_lantern": "Havslykta",
  "block.minecraft.sea_pickle": "Havsgurka",
  "block.minecraft.seagrass": "Sjögräs",
  "block.minecraft.set_spawn": "Ändrade återuppståndelsepunkten",
  "block.minecraft.short_dry_grass": "Kort torrt gräs",
  "block.minecraft.short_grass": "Kort gräs",
  "block.minecraft.shroomlight": "Svampljus",
  "block.minecraft.shulker_box": "Shulkerlåda",
  "block.minecraft.skeleton_skull": "Skelettskalle",
  "block.minecraft.skeleton_wall_skull": "Skelettskalle på vägg",
  "block.minecraft.slime_block": "Slemblock",
  "block.minecraft.small_amethyst_bud": "Liten ametistknopp",
  "block.minecraft.small_dripleaf": "Litet dropplöv",
  "block.minecraft.smithing_table": "Smedsbänk",
  "block.minecraft.smoker": "Rökugn",
  "block.minecraft.smooth_basalt": "Len basalt",
  "block.minecraft.smooth_quartz": "Lent kvartsblock",
  "block.minecraft.smooth_quartz_slab": "Len kvartsplatta",
  "block.minecraft.smooth_quartz_stairs": "Len kvartstrappa",
  "block.minecraft.smooth_red_sandstone": "Len röd sandsten",
  "block.minecraft.smooth_red_sandstone_slab": "Len röd sandstensplatta",
  "block.minecraft.smooth_red_sandstone_stairs": "Len röd sandstenstrappa",
  "block.minecraft.smooth_sandstone": "Len sandsten",
  "block.minecraft.smooth_sandstone_slab": "Len sandstensplatta",
  "block.minecraft.smooth_sandstone_stairs": "Len sandstenstrappa",
  "block.minecraft.smooth_stone": "Len sten",
  "block.minecraft.smooth_stone_slab": "Len stenplatta",
  "block.minecraft.sniffer_egg": "Sniffarägg",
  "block.minecraft.snow": "Snö",
  "block.minecraft.snow_block": "Snöblock",
  "block.minecraft.soul_campfire": "Själlägereld",
  "block.minecraft.soul_fire": "Själeld",
  "block.minecraft.soul_lantern": "Själlykta",
  "block.minecraft.soul_sand": "Själsand",
  "block.minecraft.soul_soil": "Själjord",
  "block.minecraft.soul_torch": "Själfackla",
  "block.minecraft.soul_wall_torch": "Själfackla på vägg",
  "block.minecraft.spawn.not_valid": "Din säng eller ditt laddade återuppståndelseankare saknas eller har blockerats",
  "block.minecraft.spawner": "Monsterskapare",
  "block.minecraft.spawner.desc1": "Interaktion med skapelseägg:",
  "block.minecraft.spawner.desc2": "Ändrar varelsetypen",
  "block.minecraft.sponge": "Svamp",
  "block.minecraft.spore_blossom": "Sporblomma",
  "block.minecraft.spruce_button": "Granknapp",
  "block.minecraft.spruce_door": "Grandörr",
  "block.minecraft.spruce_fence": "Granstaket",
  "block.minecraft.spruce_fence_gate": "Grangrind",
  "block.minecraft.spruce_hanging_sign": "Hängande granskylt",
  "block.minecraft.spruce_leaves": "Granbarr",
  "block.minecraft.spruce_log": "Granstam",
  "block.minecraft.spruce_planks": "Granplankor",
  "block.minecraft.spruce_pressure_plate": "Grantryckplatta",
  "block.minecraft.spruce_sapling": "Granplanta",
  "block.minecraft.spruce_shelf": "Granhylla",
  "block.minecraft.spruce_sign": "Granskylt",
  "block.minecraft.spruce_slab": "Granplatta",
  "block.minecraft.spruce_stairs": "Grantrappa",
  "block.minecraft.spruce_trapdoor": "Granfallucka",
  "block.minecraft.spruce_wall_hanging_sign": "Hängande granskylt på vägg",
  "block.minecraft.spruce_wall_sign": "Granskylt på vägg",
  "block.minecraft.spruce_wood": "Granträ",
  "block.minecraft.sticky_piston": "Klibbig kolv",
  "block.minecraft.stone": "Sten",
  "block.minecraft.stone_brick_slab": "Murstensplatta",
  "block.minecraft.stone_brick_stairs": "Murstenstrappa",
  "block.minecraft.stone_brick_wall": "Murstensmur",
  "block.minecraft.stone_bricks": "Mursten",
  "block.minecraft.stone_button": "Stenknapp",
  "block.minecraft.stone_pressure_plate": "Stentryckplatta",
  "block.minecraft.stone_slab": "Stenplatta",
  "block.minecraft.stone_stairs": "Stentrappa",
  "block.minecraft.stonecutter": "Stenskärare",
  "block.minecraft.stripped_acacia_log": "Avbarkad akaciastam",
  "block.minecraft.stripped_acacia_wood": "Avbarkat akaciaträ",
  "block.minecraft.stripped_bamboo_block": "Avskalat bambublock",
  "block.minecraft.stripped_birch_log": "Avbarkad björkstam",
  "block.minecraft.stripped_birch_wood": "Avbarkat björkträ",
  "block.minecraft.stripped_cherry_log": "Avbarkad körsbärsstam",
  "block.minecraft.stripped_cherry_wood": "Avbarkat körsbärsträ",
  "block.minecraft.stripped_crimson_hyphae": "Avskalade karmosinhyfer",
  "block.minecraft.stripped_crimson_stem": "Avskalad karmosinstam",
  "block.minecraft.stripped_dark_oak_log": "Avbarkad mörk ekstam",
  "block.minecraft.stripped_dark_oak_wood": "Avbarkat mörkt ekträ",
  "block.minecraft.stripped_jungle_log": "Avbarkad djungelträdstam",
  "block.minecraft.stripped_jungle_wood": "Avbarkat djungelträ",
  "block.minecraft.stripped_mangrove_log": "Avbarkad mangrovestam",
  "block.minecraft.stripped_mangrove_wood": "Avbarkat mangroveträ",
  "block.minecraft.stripped_oak_log": "Avbarkad ekstam",
  "block.minecraft.stripped_oak_wood": "Avbarkat ekträ",
  "block.minecraft.stripped_pale_oak_log": "Avbarkad blek ekstam",
  "block.minecraft.stripped_pale_oak_wood": "Avbarkat blekt ekträ",
  "block.minecraft.stripped_spruce_log": "Avbarkad granstam",
  "block.minecraft.stripped_spruce_wood": "Avbarkat granträ",
  "block.minecraft.stripped_warped_hyphae": "Avskalade förvrängda hyfer",
  "block.minecraft.stripped_warped_stem": "Avskalad förvrängd stam",
  "block.minecraft.structure_block": "Strukturblock",
  "block.minecraft.structure_void": "Strukturtomrum",
  "block.minecraft.sugar_cane": "Sockerrör",
  "block.minecraft.sunflower": "Solros",
  "block.minecraft.suspicious_gravel": "Misstänksamt grus",
  "block.minecraft.suspicious_sand": "Misstänksam sand",
  "block.minecraft.sweet_berry_bush": "Sötbärsbuske",
  "block.minecraft.tall_dry_grass": "Högt torrt gräs",
  "block.minecraft.tall_grass": "Högt gräs",
  "block.minecraft.tall_seagrass": "Högt sjögräs",
  "block.minecraft.target": "Måltavla",
  "block.minecraft.terracotta": "Terrakotta",
  "block.minecraft.test_block": "Testblock",
  "block.minecraft.test_instance_block": "Testinstansblock",
  "block.minecraft.tinted_glass": "Tonat glas",
  "block.minecraft.tnt": "Dynamit",
  "block.minecraft.tnt.disabled": "Dynamitexplosioner är inaktiverade",
  "block.minecraft.torch": "Fackla",
  "block.minecraft.torchflower": "Fackellilja",
  "block.minecraft.torchflower_crop": "Fackelliljeplanta",
  "block.minecraft.trapped_chest": "Kistfälla",
  "block.minecraft.trial_spawner": "Utmaningsskapare",
  "block.minecraft.tripwire": "Snubbeltråd",
  "block.minecraft.tripwire_hook": "Snubbeltrådskrok",
  "block.minecraft.tube_coral": "Orgelkorall",
  "block.minecraft.tube_coral_block": "Orgelkorallblock",
  "block.minecraft.tube_coral_fan": "Orgelkorallfläkt",
  "block.minecraft.tube_coral_wall_fan": "Orgelkorallfläkt på vägg",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuffmurstensplatta",
  "block.minecraft.tuff_brick_stairs": "Tuffmurstenstrappa",
  "block.minecraft.tuff_brick_wall": "Tuffmurstensmur",
  "block.minecraft.tuff_bricks": "Tuffmursten",
  "block.minecraft.tuff_slab": "Tuffplatta",
  "block.minecraft.tuff_stairs": "Tufftrappa",
  "block.minecraft.tuff_wall": "Tuffmur",
  "block.minecraft.turtle_egg": "Sköldpaddsägg",
  "block.minecraft.twisting_vines": "Vridande klätterväxt",
  "block.minecraft.twisting_vines_plant": "Vridande klätterväxtsplanta",
  "block.minecraft.vault": "Kassaskåp",
  "block.minecraft.verdant_froglight": "Grönskande grodljus",
  "block.minecraft.vine": "Klätterväxt",
  "block.minecraft.void_air": "Tomhetsluft",
  "block.minecraft.wall_torch": "Fackla på vägg",
  "block.minecraft.warped_button": "Förvrängd knapp",
  "block.minecraft.warped_door": "Förvrängd dörr",
  "block.minecraft.warped_fence": "Förvrängt staket",
  "block.minecraft.warped_fence_gate": "Förvrängd grind",
  "block.minecraft.warped_fungus": "Förvrängd svamp",
  "block.minecraft.warped_hanging_sign": "Hängande förvrängd skylt",
  "block.minecraft.warped_hyphae": "Förvrängda hyfer",
  "block.minecraft.warped_nylium": "Förvrängd nycel",
  "block.minecraft.warped_planks": "Förvrängda plankor",
  "block.minecraft.warped_pressure_plate": "Förvrängd tryckplatta",
  "block.minecraft.warped_roots": "Förvrängda rötter",
  "block.minecraft.warped_shelf": "Förvrängd hylla",
  "block.minecraft.warped_sign": "Förvrängd skylt",
  "block.minecraft.warped_slab": "Förvrängd platta",
  "block.minecraft.warped_stairs": "Förvrängd trappa",
  "block.minecraft.warped_stem": "Förvrängd stam",
  "block.minecraft.warped_trapdoor": "Förvrängd fallucka",
  "block.minecraft.warped_wall_hanging_sign": "Hängande förvrängd skylt på vägg",
  "block.minecraft.warped_wall_sign": "Förvrängd skylt på vägg",
  "block.minecraft.warped_wart_block": "Förvrängt vårtblock",
  "block.minecraft.water": "Vatten",
  "block.minecraft.water_cauldron": "Vattenkittel",
  "block.minecraft.waxed_chiseled_copper": "Vaxad mejslad koppar",
  "block.minecraft.waxed_copper_bars": "Vaxat koppargaller",
  "block.minecraft.waxed_copper_block": "Vaxat kopparblock",
  "block.minecraft.waxed_copper_bulb": "Vaxad kopparlampa",
  "block.minecraft.waxed_copper_chain": "Vaxad kopparkedja",
  "block.minecraft.waxed_copper_chest": "Vaxad kopparkista",
  "block.minecraft.waxed_copper_door": "Vaxad koppardörr",
  "block.minecraft.waxed_copper_golem_statue": "Vaxad koppargolemstaty",
  "block.minecraft.waxed_copper_grate": "Vaxat kopparnät",
  "block.minecraft.waxed_copper_lantern": "Vaxad kopparlykta",
  "block.minecraft.waxed_copper_trapdoor": "Vaxad kopparfallucka",
  "block.minecraft.waxed_cut_copper": "Vaxad skuren koppar",
  "block.minecraft.waxed_cut_copper_slab": "Vaxad skuren kopparplatta",
  "block.minecraft.waxed_cut_copper_stairs": "Vaxad skuren koppartrappa",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaxad exponerad mejslad koppar",
  "block.minecraft.waxed_exposed_copper": "Vaxad exponerad koppar",
  "block.minecraft.waxed_exposed_copper_bars": "Vaxat exponerat koppargaller",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaxad exponerad kopparlampa",
  "block.minecraft.waxed_exposed_copper_chain": "Vaxad exponerad kopparkedja",
  "block.minecraft.waxed_exposed_copper_chest": "Vaxad exponerad kopparkista",
  "block.minecraft.waxed_exposed_copper_door": "Vaxad exponerad koppardörr",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaxad exponerad koppargolemstaty",
  "block.minecraft.waxed_exposed_copper_grate": "Vaxat exponerat kopparnät",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaxad exponerad kopparlykta",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaxad exponerad kopparfallucka",
  "block.minecraft.waxed_exposed_cut_copper": "Vaxad exponerad skuren koppar",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaxad exponerad skuren kopparplatta",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaxad exponerad skuren koppartrappa",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaxad exponerad åskledare",
  "block.minecraft.waxed_lightning_rod": "Vaxad åskledare",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaxad ärgad mejslad koppar",
  "block.minecraft.waxed_oxidized_copper": "Vaxad ärgad koppar",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaxat ärgat koppargaller",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaxad ärgad kopparlampa",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaxad ärgad kopparkedja",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaxad ärgad kopparkista",
  "block.minecraft.waxed_oxidized_copper_door": "Vaxad ärgad koppardörr",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaxad ärgad koppargolemstaty",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaxat ärgat kopparnät",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaxad ärgad kopparlykta",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaxad ärgad kopparfallucka",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaxad ärgad skuren koppar",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaxad ärgad skuren kopparplatta",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaxad ärgad skuren koppartrappa",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaxad ärgad åskledare",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaxad väderbiten mejslad koppar",
  "block.minecraft.waxed_weathered_copper": "Vaxad väderbiten koppar",
  "block.minecraft.waxed_weathered_copper_bars": "Vaxat väderbitet koppargaller",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaxad väderbiten kopparlampa",
  "block.minecraft.waxed_weathered_copper_chain": "Vaxad väderbiten kopparkedja",
  "block.minecraft.waxed_weathered_copper_chest": "Vaxad väderbiten kopparkista",
  "block.minecraft.waxed_weathered_copper_door": "Vaxad väderbiten koppardörr",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaxad väderbiten koppargolemstaty",
  "block.minecraft.waxed_weathered_copper_grate": "Vaxat väderbitet kopparnät",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaxad väderbiten kopparlykta",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaxad väderbiten kopparfallucka",
  "block.minecraft.waxed_weathered_cut_copper": "Vaxad väderbiten skuren koppar",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaxad väderbiten skuren kopparplatta",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaxad väderbiten skuren koppartrappa",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaxad väderbiten åskledare",
  "block.minecraft.weathered_chiseled_copper": "Väderbiten mejslad koppar",
  "block.minecraft.weathered_copper": "Väderbiten koppar",
  "block.minecraft.weathered_copper_bars": "Väderbitet koppargaller",
  "block.minecraft.weathered_copper_bulb": "Väderbiten kopparlampa",
  "block.minecraft.weathered_copper_chain": "Väderbiten kopparkedja",
  "block.minecraft.weathered_copper_chest": "Väderbiten kopparkista",
  "block.minecraft.weathered_copper_door": "Väderbiten koppardörr",
  "block.minecraft.weathered_copper_golem_statue": "Väderbiten koppargolemstaty",
  "block.minecraft.weathered_copper_grate": "Väderbitet kopparnät",
  "block.minecraft.weathered_copper_lantern": "Väderbiten kopparlykta",
  "block.minecraft.weathered_copper_trapdoor": "Väderbiten kopparfallucka",
  "block.minecraft.weathered_cut_copper": "Väderbiten skuren koppar",
  "block.minecraft.weathered_cut_copper_slab": "Väderbiten skuren kopparplatta",
  "block.minecraft.weathered_cut_copper_stairs": "Väderbiten skuren koppartrappa",
  "block.minecraft.weathered_lightning_rod": "Väderbiten åskledare",
  "block.minecraft.weeping_vines": "Tårklätterväxt",
  "block.minecraft.weeping_vines_plant": "Tårklätterväxtsplanta",
  "block.minecraft.wet_sponge": "Våt svamp",
  "block.minecraft.wheat": "Vetegrödor",
  "block.minecraft.white_banner": "Vit fana",
  "block.minecraft.white_bed": "Vit säng",
  "block.minecraft.white_candle": "Vitt stearinljus",
  "block.minecraft.white_candle_cake": "Tårta med vitt stearinljus",
  "block.minecraft.white_carpet": "Vit matta",
  "block.minecraft.white_concrete": "Vit betong",
  "block.minecraft.white_concrete_powder": "Vitt betongpulver",
  "block.minecraft.white_glazed_terracotta": "Vitglaserad terrakotta",
  "block.minecraft.white_shulker_box": "Vit shulkerlåda",
  "block.minecraft.white_stained_glass": "Vitfärgat glas",
  "block.minecraft.white_stained_glass_pane": "Vitfärgad glasruta",
  "block.minecraft.white_terracotta": "Vit terrakotta",
  "block.minecraft.white_tulip": "Vit tulpan",
  "block.minecraft.white_wool": "Vit ull",
  "block.minecraft.wildflowers": "Vildblommor",
  "block.minecraft.wither_rose": "Witherros",
  "block.minecraft.wither_skeleton_skull": "Witherskelettskalle",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelettskalle på vägg",
  "block.minecraft.yellow_banner": "Gul fana",
  "block.minecraft.yellow_bed": "Gul säng",
  "block.minecraft.yellow_candle": "Gult stearinljus",
  "block.minecraft.yellow_candle_cake": "Tårta med gult stearinljus",
  "block.minecraft.yellow_carpet": "Gul matta",
  "block.minecraft.yellow_concrete": "Gul betong",
  "block.minecraft.yellow_concrete_powder": "Gult betongpulver",
  "block.minecraft.yellow_glazed_terracotta": "Gulglaserad terrakotta",
  "block.minecraft.yellow_shulker_box": "Gul shulkerlåda",
  "block.minecraft.yellow_stained_glass": "Gulfärgat glas",
  "block.minecraft.yellow_stained_glass_pane": "Gulfärgad glasruta",
  "block.minecraft.yellow_terracotta": "Gul terrakotta",
  "block.minecraft.yellow_wool": "Gul ull",
  "block.minecraft.zombie_head": "Zombiehuvud",
  "block.minecraft.zombie_wall_head": "Zombiehuvud på vägg",
  "item.minecraft.acacia_boat": "Akaciabåt",
  "item.minecraft.acacia_chest_boat": "Akaciabåt med kista",
  "item.minecraft.allay_spawn_egg": "Skapelseägg för hjälpande ande",
  "item.minecraft.amethyst_shard": "Ametistskärva",
  "item.minecraft.angler_pottery_shard": "Keramikskärva med fiskespö",
  "item.minecraft.angler_pottery_sherd": "Keramikskärva med fiskespö",
  "item.minecraft.apple": "Äpple",
  "item.minecraft.archer_pottery_shard": "Keramikskärva med pilbåge",
  "item.minecraft.archer_pottery_sherd": "Keramikskärva med pilbåge",
  "item.minecraft.armadillo_scute": "Bältdjurshornplåt",
  "item.minecraft.armadillo_spawn_egg": "Skapelseägg för bältdjur",
  "item.minecraft.armor_stand": "Rustningsställ",
  "item.minecraft.arms_up_pottery_shard": "Keramikskärva med uppsträckta armar",
  "item.minecraft.arms_up_pottery_sherd": "Keramikskärva med uppsträckta armar",
  "item.minecraft.arrow": "Pil",
  "item.minecraft.axolotl_bucket": "Hink med axolotl",
  "item.minecraft.axolotl_spawn_egg": "Skapelseägg för axolotl",
  "item.minecraft.baked_potato": "Bakad potatis",
  "item.minecraft.bamboo_chest_raft": "Bambuflotte med kista",
  "item.minecraft.bamboo_raft": "Bambuflotte",
  "item.minecraft.bat_spawn_egg": "Skapelseägg för fladdermus",
  "item.minecraft.bee_spawn_egg": "Skapelseägg för bi",
  "item.minecraft.beef": "Rå biff",
  "item.minecraft.beetroot": "Rödbeta",
  "item.minecraft.beetroot_seeds": "Rödbetsfrön",
  "item.minecraft.beetroot_soup": "Rödbetssoppa",
  "item.minecraft.birch_boat": "Björkbåt",
  "item.minecraft.birch_chest_boat": "Björkbåt med kista",
  "item.minecraft.black_bundle": "Svart påse",
  "item.minecraft.black_dye": "Svart färg",
  "item.minecraft.black_harness": "Svart sele",
  "item.minecraft.blade_pottery_shard": "Keramikskärva med svärd",
  "item.minecraft.blade_pottery_sherd": "Keramikskärva med svärd",
  "item.minecraft.blaze_powder": "Brännpulver",
  "item.minecraft.blaze_rod": "Brännstav",
  "item.minecraft.blaze_spawn_egg": "Skapelseägg för brännare",
  "item.minecraft.blue_bundle": "Blå påse",
  "item.minecraft.blue_dye": "Blå färg",
  "item.minecraft.blue_egg": "Blått ägg",
  "item.minecraft.blue_harness": "Blå sele",
  "item.minecraft.bogged_spawn_egg": "Skapelseägg för sumpigt skelett",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bultförsedda rustningsdetaljer",
  "item.minecraft.bone": "Ben",
  "item.minecraft.bone_meal": "Benmjöl",
  "item.minecraft.book": "Bok",
  "item.minecraft.bordure_indented_banner_pattern": "Fanemönster för taggig ram",
  "item.minecraft.bow": "Pilbåge",
  "item.minecraft.bowl": "Skål",
  "item.minecraft.bread": "Bröd",
  "item.minecraft.breeze_rod": "Vindstav",
  "item.minecraft.breeze_spawn_egg": "Skapelseägg för vindväsen",
  "item.minecraft.brewer_pottery_shard": "Keramikskärva med brygd",
  "item.minecraft.brewer_pottery_sherd": "Keramikskärva med brygd",
  "item.minecraft.brewing_stand": "Brygdställ",
  "item.minecraft.brick": "Tegelsten",
  "item.minecraft.brown_bundle": "Brun påse",
  "item.minecraft.brown_dye": "Brun färg",
  "item.minecraft.brown_egg": "Brunt ägg",
  "item.minecraft.brown_harness": "Brun sele",
  "item.minecraft.brush": "Borste",
  "item.minecraft.bucket": "Hink",
  "item.minecraft.bundle": "Påse",
  "item.minecraft.bundle.empty": "Tom",
  "item.minecraft.bundle.empty.description": "Kan förvara 64 föremål av olika slag",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Keramikskärva med eldslåga",
  "item.minecraft.burn_pottery_sherd": "Keramikskärva med eldslåga",
  "item.minecraft.camel_husk_spawn_egg": "Skapelseägg för uttorkad kamel",
  "item.minecraft.camel_spawn_egg": "Skapelseägg för kamel",
  "item.minecraft.carrot": "Morot",
  "item.minecraft.carrot_on_a_stick": "Morot på pinne",
  "item.minecraft.cat_spawn_egg": "Skapelseägg för katt",
  "item.minecraft.cauldron": "Kittel",
  "item.minecraft.cave_spider_spawn_egg": "Skapelseägg för grottspindel",
  "item.minecraft.chainmail_boots": "Ringbrynjestövlar",
  "item.minecraft.chainmail_chestplate": "Ringbrynjeskjorta",
  "item.minecraft.chainmail_helmet": "Ringbrynjehuva",
  "item.minecraft.chainmail_leggings": "Ringbrynjebyxor",
  "item.minecraft.charcoal": "Träkol",
  "item.minecraft.cherry_boat": "Körsbärsbåt",
  "item.minecraft.cherry_chest_boat": "Körsbärsbåt med kista",
  "item.minecraft.chest_minecart": "Gruvvagn med kista",
  "item.minecraft.chicken": "Rå kyckling",
  "item.minecraft.chicken_spawn_egg": "Skapelseägg för höna",
  "item.minecraft.chorus_fruit": "Körfrukt",
  "item.minecraft.clay_ball": "Lerboll",
  "item.minecraft.clock": "Klocka",
  "item.minecraft.coal": "Kol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Kustutsmyckade rustningsdetaljer",
  "item.minecraft.cocoa_beans": "Kakaobönor",
  "item.minecraft.cod": "Rå torsk",
  "item.minecraft.cod_bucket": "Hink med torsk",
  "item.minecraft.cod_spawn_egg": "Skapelseägg för torsk",
  "item.minecraft.command_block_minecart": "Gruvvagn med kommandoblock",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Tillagad biff",
  "item.minecraft.cooked_chicken": "Tillagad kyckling",
  "item.minecraft.cooked_cod": "Tillagad torsk",
  "item.minecraft.cooked_mutton": "Tillagat fårkött",
  "item.minecraft.cooked_porkchop": "Tillagad fläskkotlett",
  "item.minecraft.cooked_rabbit": "Tillagad kanin",
  "item.minecraft.cooked_salmon": "Tillagad lax",
  "item.minecraft.cookie": "Kaka",
  "item.minecraft.copper_axe": "Kopparyxa",
  "item.minecraft.copper_boots": "Kopparstövlar",
  "item.minecraft.copper_chestplate": "Kopparharnesk",
  "item.minecraft.copper_golem_spawn_egg": "Skapelseägg för koppargolem",
  "item.minecraft.copper_helmet": "Kopparhjälm",
  "item.minecraft.copper_hoe": "Kopparflåhacka",
  "item.minecraft.copper_horse_armor": "Kopparhästrustning",
  "item.minecraft.copper_ingot": "Koppartacka",
  "item.minecraft.copper_leggings": "Kopparbyxor",
  "item.minecraft.copper_nautilus_armor": "Kopparpärlbåtsrustning",
  "item.minecraft.copper_nugget": "Kopparklimp",
  "item.minecraft.copper_pickaxe": "Kopparhacka",
  "item.minecraft.copper_shovel": "Kopparspade",
  "item.minecraft.copper_spear": "Kopparspjut",
  "item.minecraft.copper_sword": "Kopparsvärd",
  "item.minecraft.cow_spawn_egg": "Skapelseägg för ko",
  "item.minecraft.creaking_spawn_egg": "Skapelseägg för knarrträd",
  "item.minecraft.creeper_banner_pattern": "Fanemönster",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Fanemönster för creeper",
  "item.minecraft.creeper_spawn_egg": "Skapelseägg för creeper",
  "item.minecraft.crossbow": "Armborst",
  "item.minecraft.crossbow.projectile": "Projektil:",
  "item.minecraft.crossbow.projectile.multiple": "Laddade projektiler: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Laddad projektil: %s",
  "item.minecraft.cyan_bundle": "Turkos påse",
  "item.minecraft.cyan_dye": "Turkos färg",
  "item.minecraft.cyan_harness": "Turkos sele",
  "item.minecraft.danger_pottery_shard": "Keramikskärva med creeper",
  "item.minecraft.danger_pottery_sherd": "Keramikskärva med creeper",
  "item.minecraft.dark_oak_boat": "Mörk ekbåt",
  "item.minecraft.dark_oak_chest_boat": "Mörk ekbåt med kista",
  "item.minecraft.debug_stick": "Felsökningspinne",
  "item.minecraft.debug_stick.empty": "%s har inga egenskaper",
  "item.minecraft.debug_stick.select": "Valde \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "Ändrade \"%s\" till %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantyxa",
  "item.minecraft.diamond_boots": "Diamantstövlar",
  "item.minecraft.diamond_chestplate": "Diamantharnesk",
  "item.minecraft.diamond_helmet": "Diamanthjälm",
  "item.minecraft.diamond_hoe": "Diamantflåhacka",
  "item.minecraft.diamond_horse_armor": "Diamanthästrustning",
  "item.minecraft.diamond_leggings": "Diamantbyxor",
  "item.minecraft.diamond_nautilus_armor": "Diamantpärlbåtsrustning",
  "item.minecraft.diamond_pickaxe": "Diamanthacka",
  "item.minecraft.diamond_shovel": "Diamantspade",
  "item.minecraft.diamond_spear": "Diamantspjut",
  "item.minecraft.diamond_sword": "Diamantsvärd",
  "item.minecraft.disc_fragment_5": "Skivfragment",
  "item.minecraft.disc_fragment_5.desc": "Musikskiva – 5",
  "item.minecraft.dolphin_spawn_egg": "Skapelseägg för delfin",
  "item.minecraft.donkey_spawn_egg": "Skapelseägg för åsna",
  "item.minecraft.dragon_breath": "Drakeld",
  "item.minecraft.dried_kelp": "Torkad kelp",
  "item.minecraft.drowned_spawn_egg": "Skapelseägg för drunknad zombie",
  "item.minecraft.dune_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ökenartade rustningsdetaljer",
  "item.minecraft.echo_shard": "Ekoskärva",
  "item.minecraft.egg": "Ägg",
  "item.minecraft.elder_guardian_spawn_egg": "Skapelseägg för urväktare",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Förtrollad bok",
  "item.minecraft.enchanted_golden_apple": "Förtrollat gyllene äpple",
  "item.minecraft.end_crystal": "Endkristall",
  "item.minecraft.ender_dragon_spawn_egg": "Skapelseägg för enderdrake",
  "item.minecraft.ender_eye": "Enderöga",
  "item.minecraft.ender_pearl": "Enderpärla",
  "item.minecraft.enderman_spawn_egg": "Skapelseägg för enderman",
  "item.minecraft.endermite_spawn_egg": "Skapelseägg för endermite",
  "item.minecraft.evoker_spawn_egg": "Skapelseägg för frammanare",
  "item.minecraft.experience_bottle": "Förtrollningsflaska",
  "item.minecraft.explorer_pottery_shard": "Keramikskärva med karta",
  "item.minecraft.explorer_pottery_sherd": "Keramikskärva med karta",
  "item.minecraft.eye_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ögondekorerade rustningsdetaljer",
  "item.minecraft.feather": "Fjäder",
  "item.minecraft.fermented_spider_eye": "Jäst spindelöga",
  "item.minecraft.field_masoned_banner_pattern": "Fanemönster för tegelmönster",
  "item.minecraft.filled_map": "Karta",
  "item.minecraft.fire_charge": "Eldladdning",
  "item.minecraft.firework_rocket": "Fyrverkeriraket",
  "item.minecraft.firework_rocket.flight": "Flygtid:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Fyrverkeristjärna",
  "item.minecraft.firework_star.black": "Svart",
  "item.minecraft.firework_star.blue": "Blå",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Anpassad",
  "item.minecraft.firework_star.cyan": "Turkos",
  "item.minecraft.firework_star.fade_to": "Tona till",
  "item.minecraft.firework_star.flicker": "Glimmande",
  "item.minecraft.firework_star.gray": "Grå",
  "item.minecraft.firework_star.green": "Grön",
  "item.minecraft.firework_star.light_blue": "Ljusblå",
  "item.minecraft.firework_star.light_gray": "Ljusgrå",
  "item.minecraft.firework_star.lime": "Limegrön",
  "item.minecraft.firework_star.magenta": "Ljuslila",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Lila",
  "item.minecraft.firework_star.red": "Röd",
  "item.minecraft.firework_star.shape": "Okänd form",
  "item.minecraft.firework_star.shape.burst": "Explosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperformad",
  "item.minecraft.firework_star.shape.large_ball": "Stort klot",
  "item.minecraft.firework_star.shape.small_ball": "Litet klot",
  "item.minecraft.firework_star.shape.star": "Stjärnformad",
  "item.minecraft.firework_star.trail": "Spår",
  "item.minecraft.firework_star.white": "Vit",
  "item.minecraft.firework_star.yellow": "Gul",
  "item.minecraft.fishing_rod": "Fiskespö",
  "item.minecraft.flint": "Flinta",
  "item.minecraft.flint_and_steel": "Tändstål",
  "item.minecraft.flow_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Virvelformade rustningsdetaljer",
  "item.minecraft.flow_banner_pattern": "Fanemönster",
  "item.minecraft.flow_banner_pattern.desc": "Virvel",
  "item.minecraft.flow_banner_pattern.new": "Fanemönster för virvel",
  "item.minecraft.flow_pottery_sherd": "Keramikskärva med virvel",
  "item.minecraft.flower_banner_pattern": "Fanemönster",
  "item.minecraft.flower_banner_pattern.desc": "Blomma",
  "item.minecraft.flower_banner_pattern.new": "Fanemönster för blomma",
  "item.minecraft.flower_pot": "Blomkruka",
  "item.minecraft.fox_spawn_egg": "Skapelseägg för räv",
  "item.minecraft.friend_pottery_shard": "Keramikskärva med vänligt ansikte",
  "item.minecraft.friend_pottery_sherd": "Keramikskärva med vänligt ansikte",
  "item.minecraft.frog_spawn_egg": "Skapelseägg för groda",
  "item.minecraft.furnace_minecart": "Gruvvagn med ugn",
  "item.minecraft.ghast_spawn_egg": "Skapelseägg för ghast",
  "item.minecraft.ghast_tear": "Ghasttår",
  "item.minecraft.glass_bottle": "Glasflaska",
  "item.minecraft.glistering_melon_slice": "Gnistrande melonskiva",
  "item.minecraft.globe_banner_pattern": "Fanemönster",
  "item.minecraft.globe_banner_pattern.desc": "Glob",
  "item.minecraft.globe_banner_pattern.new": "Fanemönster för glob",
  "item.minecraft.glow_berries": "Självlysande bär",
  "item.minecraft.glow_ink_sac": "Självlysande bläcksäck",
  "item.minecraft.glow_item_frame": "Självlysande föremålsram",
  "item.minecraft.glow_squid_spawn_egg": "Skapelseägg för självlysande bläckfisk",
  "item.minecraft.glowstone_dust": "Glödstensdamm",
  "item.minecraft.goat_horn": "Gethorn",
  "item.minecraft.goat_spawn_egg": "Skapelseägg för get",
  "item.minecraft.gold_ingot": "Guldtacka",
  "item.minecraft.gold_nugget": "Guldklimp",
  "item.minecraft.golden_apple": "Gyllene äpple",
  "item.minecraft.golden_axe": "Guldyxa",
  "item.minecraft.golden_boots": "Guldstövlar",
  "item.minecraft.golden_carrot": "Gyllene morot",
  "item.minecraft.golden_chestplate": "Guldharnesk",
  "item.minecraft.golden_helmet": "Guldhjälm",
  "item.minecraft.golden_hoe": "Guldflåhacka",
  "item.minecraft.golden_horse_armor": "Guldhästrustning",
  "item.minecraft.golden_leggings": "Guldbyxor",
  "item.minecraft.golden_nautilus_armor": "Guldpärlbåtsrustning",
  "item.minecraft.golden_pickaxe": "Guldhacka",
  "item.minecraft.golden_shovel": "Guldspade",
  "item.minecraft.golden_spear": "Guldspjut",
  "item.minecraft.golden_sword": "Guldsvärd",
  "item.minecraft.gray_bundle": "Grå påse",
  "item.minecraft.gray_dye": "Grå färg",
  "item.minecraft.gray_harness": "Grå sele",
  "item.minecraft.green_bundle": "Grön påse",
  "item.minecraft.green_dye": "Grön färg",
  "item.minecraft.green_harness": "Grön sele",
  "item.minecraft.guardian_spawn_egg": "Skapelseägg för väktare",
  "item.minecraft.gunpowder": "Krut",
  "item.minecraft.guster_banner_pattern": "Fanemönster",
  "item.minecraft.guster_banner_pattern.desc": "Vindväsen",
  "item.minecraft.guster_banner_pattern.new": "Fanemönster för vindväsen",
  "item.minecraft.guster_pottery_sherd": "Keramikskärva med vindväsen",
  "item.minecraft.happy_ghast_spawn_egg": "Skapelseägg för glad ghast",
  "item.minecraft.harness": "Sele",
  "item.minecraft.heart_of_the_sea": "Havets hjärta",
  "item.minecraft.heart_pottery_shard": "Keramikskärva med hjärta",
  "item.minecraft.heart_pottery_sherd": "Keramikskärva med hjärta",
  "item.minecraft.heartbreak_pottery_shard": "Keramikskärva med krossat hjärta",
  "item.minecraft.heartbreak_pottery_sherd": "Keramikskärva med krossat hjärta",
  "item.minecraft.hoglin_spawn_egg": "Skapelseägg för hoglin",
  "item.minecraft.honey_bottle": "Honungsflaska",
  "item.minecraft.honeycomb": "Vaxkaka",
  "item.minecraft.hopper_minecart": "Gruvvagn med tratt",
  "item.minecraft.horse_spawn_egg": "Skapelseägg för häst",
  "item.minecraft.host_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.host_armor_trim_smithing_template.new": "Gästgivande rustningsdetaljer",
  "item.minecraft.howl_pottery_shard": "Keramikskärva med varg",
  "item.minecraft.howl_pottery_sherd": "Keramikskärva med varg",
  "item.minecraft.husk_spawn_egg": "Skapelseägg för uttorkad zombie",
  "item.minecraft.ink_sac": "Bläcksäck",
  "item.minecraft.iron_axe": "Järnyxa",
  "item.minecraft.iron_boots": "Järnstövlar",
  "item.minecraft.iron_chestplate": "Järnharnesk",
  "item.minecraft.iron_golem_spawn_egg": "Skapelseägg för järngolem",
  "item.minecraft.iron_helmet": "Järnhjälm",
  "item.minecraft.iron_hoe": "Järnflåhacka",
  "item.minecraft.iron_horse_armor": "Järnhästrustning",
  "item.minecraft.iron_ingot": "Järntacka",
  "item.minecraft.iron_leggings": "Järnbyxor",
  "item.minecraft.iron_nautilus_armor": "Järnpärlbåtsrustning",
  "item.minecraft.iron_nugget": "Järnklimp",
  "item.minecraft.iron_pickaxe": "Järnhacka",
  "item.minecraft.iron_shovel": "Järnspade",
  "item.minecraft.iron_spear": "Järnspjut",
  "item.minecraft.iron_sword": "Järnsvärd",
  "item.minecraft.item_frame": "Föremålsram",
  "item.minecraft.jungle_boat": "Djungelbåt",
  "item.minecraft.jungle_chest_boat": "Djungelbåt med kista",
  "item.minecraft.knowledge_book": "Kunskapsbok",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Lavahink",
  "item.minecraft.lead": "Koppel",
  "item.minecraft.leather": "Läder",
  "item.minecraft.leather_boots": "Läderstövlar",
  "item.minecraft.leather_chestplate": "Lädertunika",
  "item.minecraft.leather_helmet": "Lädermössa",
  "item.minecraft.leather_horse_armor": "Läderhästrustning",
  "item.minecraft.leather_leggings": "Läderbyxor",
  "item.minecraft.light_blue_bundle": "Ljusblå påse",
  "item.minecraft.light_blue_dye": "Ljusblå färg",
  "item.minecraft.light_blue_harness": "Ljusblå sele",
  "item.minecraft.light_gray_bundle": "Ljusgrå påse",
  "item.minecraft.light_gray_dye": "Ljusgrå färg",
  "item.minecraft.light_gray_harness": "Ljusgrå sele",
  "item.minecraft.lime_bundle": "Limegrön påse",
  "item.minecraft.lime_dye": "Limegrön färg",
  "item.minecraft.lime_harness": "Limegrön sele",
  "item.minecraft.lingering_potion": "Kvardröjande brygd",
  "item.minecraft.lingering_potion.effect.awkward": "Kvardröjande tafflig brygd",
  "item.minecraft.lingering_potion.effect.empty": "Kvardröjande icke-tillverkningsbar brygd",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Kvardröjande eldresistensbrygd",
  "item.minecraft.lingering_potion.effect.harming": "Kvardröjande skadebrygd",
  "item.minecraft.lingering_potion.effect.healing": "Kvardröjande läkningsbrygd",
  "item.minecraft.lingering_potion.effect.infested": "Kvardröjande infestationsbrygd",
  "item.minecraft.lingering_potion.effect.invisibility": "Kvardröjande osynlighetsbrygd",
  "item.minecraft.lingering_potion.effect.leaping": "Kvardröjande hoppstrykebrygd",
  "item.minecraft.lingering_potion.effect.levitation": "Kvardröjande levitationsbrygd",
  "item.minecraft.lingering_potion.effect.luck": "Kvardröjande turbrygd",
  "item.minecraft.lingering_potion.effect.mundane": "Banal kvardröjande brygd",
  "item.minecraft.lingering_potion.effect.night_vision": "Kvardröjande mörkerseendebrygd",
  "item.minecraft.lingering_potion.effect.oozing": "Kvardröjande slemmighetsbrygd",
  "item.minecraft.lingering_potion.effect.poison": "Kvardröjande giftbrygd",
  "item.minecraft.lingering_potion.effect.regeneration": "Kvardröjande återhämtningsbrygd",
  "item.minecraft.lingering_potion.effect.slow_falling": "Kvardröjande antigravitationsbrygd",
  "item.minecraft.lingering_potion.effect.slowness": "Kvardröjande långsamhetsbrygd",
  "item.minecraft.lingering_potion.effect.strength": "Kvardröjande styrkebrygd",
  "item.minecraft.lingering_potion.effect.swiftness": "Kvardröjande snabbhetsbrygd",
  "item.minecraft.lingering_potion.effect.thick": "Tjock kvardröjande brygd",
  "item.minecraft.lingering_potion.effect.turtle_master": "Sköldpaddsmästarens kvardröjande brygd",
  "item.minecraft.lingering_potion.effect.water": "Kvardröjande vattenflaska",
  "item.minecraft.lingering_potion.effect.water_breathing": "Kvardröjande vattenandningsbrygd",
  "item.minecraft.lingering_potion.effect.weakness": "Kvardröjande svaghetsbrygd",
  "item.minecraft.lingering_potion.effect.weaving": "Kvardröjande spindelnätsbrygd",
  "item.minecraft.lingering_potion.effect.wind_charged": "Kvardröjande vindladdningsbrygd",
  "item.minecraft.llama_spawn_egg": "Skapelseägg för lama",
  "item.minecraft.lodestone_compass": "Magnetitkompass",
  "item.minecraft.mace": "Stridsklubba",
  "item.minecraft.magenta_bundle": "Ljuslila påse",
  "item.minecraft.magenta_dye": "Ljuslila färg",
  "item.minecraft.magenta_harness": "Ljuslila sele",
  "item.minecraft.magma_cream": "Magmakräm",
  "item.minecraft.magma_cube_spawn_egg": "Skapelseägg för magmakub",
  "item.minecraft.mangrove_boat": "Mangrovebåt",
  "item.minecraft.mangrove_chest_boat": "Mangrovebåt med kista",
  "item.minecraft.map": "Tom karta",
  "item.minecraft.melon_seeds": "Melonfrön",
  "item.minecraft.melon_slice": "Melonskiva",
  "item.minecraft.milk_bucket": "Mjölkhink",
  "item.minecraft.minecart": "Gruvvagn",
  "item.minecraft.miner_pottery_shard": "Keramikskärva med hacka",
  "item.minecraft.miner_pottery_sherd": "Keramikskärva med hacka",
  "item.minecraft.mojang_banner_pattern": "Fanemönster",
  "item.minecraft.mojang_banner_pattern.desc": "Mojäng",
  "item.minecraft.mojang_banner_pattern.new": "Fanemönster för mojäng",
  "item.minecraft.mooshroom_spawn_egg": "Skapelseägg för mooshroom",
  "item.minecraft.mourner_pottery_shard": "Keramikskärva med vakt",
  "item.minecraft.mourner_pottery_sherd": "Keramikskärva med vakt",
  "item.minecraft.mule_spawn_egg": "Skapelseägg för mula",
  "item.minecraft.mushroom_stew": "Svampstuvning",
  "item.minecraft.music_disc_11": "Musikskiva",
  "item.minecraft.music_disc_11.desc": "C418 – 11",
  "item.minecraft.music_disc_13": "Musikskiva",
  "item.minecraft.music_disc_13.desc": "C418 – 13",
  "item.minecraft.music_disc_5": "Musikskiva",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg – 5",
  "item.minecraft.music_disc_blocks": "Musikskiva",
  "item.minecraft.music_disc_blocks.desc": "C418 – blocks",
  "item.minecraft.music_disc_cat": "Musikskiva",
  "item.minecraft.music_disc_cat.desc": "C418 – cat",
  "item.minecraft.music_disc_chirp": "Musikskiva",
  "item.minecraft.music_disc_chirp.desc": "C418 – chirp",
  "item.minecraft.music_disc_creator": "Musikskiva",
  "item.minecraft.music_disc_creator.desc": "Lena Raine – Creator",
  "item.minecraft.music_disc_creator_music_box": "Musikskiva",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine – Creator (speldosa)",
  "item.minecraft.music_disc_far": "Musikskiva",
  "item.minecraft.music_disc_far.desc": "C418 – far",
  "item.minecraft.music_disc_lava_chicken": "Musikskiva",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions – Lava Chicken",
  "item.minecraft.music_disc_mall": "Musikskiva",
  "item.minecraft.music_disc_mall.desc": "C418 – mall",
  "item.minecraft.music_disc_mellohi": "Musikskiva",
  "item.minecraft.music_disc_mellohi.desc": "C418 – mellohi",
  "item.minecraft.music_disc_otherside": "Musikskiva",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine – otherside",
  "item.minecraft.music_disc_pigstep": "Musikskiva",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine – Pigstep",
  "item.minecraft.music_disc_precipice": "Musikskiva",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof – Precipice",
  "item.minecraft.music_disc_relic": "Musikskiva",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof – Relic",
  "item.minecraft.music_disc_stal": "Musikskiva",
  "item.minecraft.music_disc_stal.desc": "C418 – stal",
  "item.minecraft.music_disc_strad": "Musikskiva",
  "item.minecraft.music_disc_strad.desc": "C418 – strad",
  "item.minecraft.music_disc_tears": "Musikskiva",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy – Tears",
  "item.minecraft.music_disc_wait": "Musikskiva",
  "item.minecraft.music_disc_wait.desc": "C418 – wait",
  "item.minecraft.music_disc_ward": "Musikskiva",
  "item.minecraft.music_disc_ward.desc": "C418 – ward",
  "item.minecraft.mutton": "Rått fårkött",
  "item.minecraft.name_tag": "Namnskylt",
  "item.minecraft.nautilus_shell": "Pärlbåtsskal",
  "item.minecraft.nautilus_spawn_egg": "Skapelseägg för pärlbåt",
  "item.minecraft.nether_brick": "Nethertegelsten",
  "item.minecraft.nether_star": "Netherstjärna",
  "item.minecraft.nether_wart": "Nethervårta",
  "item.minecraft.netherite_axe": "Netherityxa",
  "item.minecraft.netherite_boots": "Netheritstövlar",
  "item.minecraft.netherite_chestplate": "Netheritharnesk",
  "item.minecraft.netherite_helmet": "Netherithjälm",
  "item.minecraft.netherite_hoe": "Netheritflåhacka",
  "item.minecraft.netherite_horse_armor": "Netherithästrustning",
  "item.minecraft.netherite_ingot": "Netherittacka",
  "item.minecraft.netherite_leggings": "Netheritbyxor",
  "item.minecraft.netherite_nautilus_armor": "Netheritpärlbåtsrustning",
  "item.minecraft.netherite_pickaxe": "Netherithacka",
  "item.minecraft.netherite_scrap": "Netheritstycke",
  "item.minecraft.netherite_shovel": "Netheritspade",
  "item.minecraft.netherite_spear": "Netheritspjut",
  "item.minecraft.netherite_sword": "Netheritsvärd",
  "item.minecraft.netherite_upgrade_smithing_template": "Smidesmall",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherituppgradering",
  "item.minecraft.oak_boat": "Ekbåt",
  "item.minecraft.oak_chest_boat": "Ekbåt med kista",
  "item.minecraft.ocelot_spawn_egg": "Skapelseägg för ozelot",
  "item.minecraft.ominous_bottle": "Oroväckande flaska",
  "item.minecraft.ominous_trial_key": "Oroväckande utmaningsnyckel",
  "item.minecraft.orange_bundle": "Orange påse",
  "item.minecraft.orange_dye": "Orange färg",
  "item.minecraft.orange_harness": "Orange sele",
  "item.minecraft.painting": "Tavla",
  "item.minecraft.pale_oak_boat": "Blek ekbåt",
  "item.minecraft.pale_oak_chest_boat": "Blek ekbåt med kista",
  "item.minecraft.panda_spawn_egg": "Skapelseägg för panda",
  "item.minecraft.paper": "Papper",
  "item.minecraft.parched_spawn_egg": "Skapelseägg för uttorkat skelett",
  "item.minecraft.parrot_spawn_egg": "Skapelseägg för papegoja",
  "item.minecraft.phantom_membrane": "Fantommembran",
  "item.minecraft.phantom_spawn_egg": "Skapelseägg för fantom",
  "item.minecraft.pig_spawn_egg": "Skapelseägg för gris",
  "item.minecraft.piglin_banner_pattern": "Fanemönster",
  "item.minecraft.piglin_banner_pattern.desc": "Tryne",
  "item.minecraft.piglin_banner_pattern.new": "Fanemönster för tryne",
  "item.minecraft.piglin_brute_spawn_egg": "Skapelseägg för piglinbarbar",
  "item.minecraft.piglin_spawn_egg": "Skapelseägg för piglin",
  "item.minecraft.pillager_spawn_egg": "Skapelseägg för plundrare",
  "item.minecraft.pink_bundle": "Rosa påse",
  "item.minecraft.pink_dye": "Rosa färg",
  "item.minecraft.pink_harness": "Rosa sele",
  "item.minecraft.pitcher_plant": "Kannranka",
  "item.minecraft.pitcher_pod": "Kannrankeskida",
  "item.minecraft.plenty_pottery_shard": "Keramikskärva med kista",
  "item.minecraft.plenty_pottery_sherd": "Keramikskärva med kista",
  "item.minecraft.poisonous_potato": "Giftig potatis",
  "item.minecraft.polar_bear_spawn_egg": "Skapelseägg för isbjörn",
  "item.minecraft.popped_chorus_fruit": "Utslagen körfrukt",
  "item.minecraft.porkchop": "Rå fläskkotlett",
  "item.minecraft.potato": "Potatis",
  "item.minecraft.potion": "Brygd",
  "item.minecraft.potion.effect.awkward": "Tafflig brygd",
  "item.minecraft.potion.effect.empty": "Icke-tillverkningsbar brygd",
  "item.minecraft.potion.effect.fire_resistance": "Eldresistensbrygd",
  "item.minecraft.potion.effect.harming": "Skadebrygd",
  "item.minecraft.potion.effect.healing": "Läkningsbrygd",
  "item.minecraft.potion.effect.infested": "Infestationsbrygd",
  "item.minecraft.potion.effect.invisibility": "Osynlighetsbrygd",
  "item.minecraft.potion.effect.leaping": "Hoppstyrkebrygd",
  "item.minecraft.potion.effect.levitation": "Levitationsbrygd",
  "item.minecraft.potion.effect.luck": "Turbrygd",
  "item.minecraft.potion.effect.mundane": "Banal brygd",
  "item.minecraft.potion.effect.night_vision": "Mörkerseendebrygd",
  "item.minecraft.potion.effect.oozing": "Slemmighetsbrygd",
  "item.minecraft.potion.effect.poison": "Giftbrygd",
  "item.minecraft.potion.effect.regeneration": "Återhämtningsbrygd",
  "item.minecraft.potion.effect.slow_falling": "Antigravitationsbrygd",
  "item.minecraft.potion.effect.slowness": "Långsamhetsbrygd",
  "item.minecraft.potion.effect.strength": "Styrkebrygd",
  "item.minecraft.potion.effect.swiftness": "Snabbhetsbrygd",
  "item.minecraft.potion.effect.thick": "Tjock brygd",
  "item.minecraft.potion.effect.turtle_master": "Sköldpaddsmästarens brygd",
  "item.minecraft.potion.effect.water": "Vattenflaska",
  "item.minecraft.potion.effect.water_breathing": "Vattenandningsbrygd",
  "item.minecraft.potion.effect.weakness": "Svaghetsbrygd",
  "item.minecraft.potion.effect.weaving": "Spindelnätsbrygd",
  "item.minecraft.potion.effect.wind_charged": "Vindladdningsbrygd",
  "item.minecraft.pottery_shard_archer": "Keramikskärva med pilbåge",
  "item.minecraft.pottery_shard_arms_up": "Keramikskärva med uppsträckta armar",
  "item.minecraft.pottery_shard_prize": "Keramikskärva med ädelsten",
  "item.minecraft.pottery_shard_skull": "Keramikskärva med dödskalle",
  "item.minecraft.powder_snow_bucket": "Pudersnöhink",
  "item.minecraft.prismarine_crystals": "Prismarinkristaller",
  "item.minecraft.prismarine_shard": "Prismarinskärva",
  "item.minecraft.prize_pottery_shard": "Keramikskärva med ädelsten",
  "item.minecraft.prize_pottery_sherd": "Keramikskärva med ädelsten",
  "item.minecraft.pufferfish": "Blåsfisk",
  "item.minecraft.pufferfish_bucket": "Hink med blåsfisk",
  "item.minecraft.pufferfish_spawn_egg": "Skapelseägg för blåsfisk",
  "item.minecraft.pumpkin_pie": "Pumpapaj",
  "item.minecraft.pumpkin_seeds": "Pumpafrön",
  "item.minecraft.purple_bundle": "Lila påse",
  "item.minecraft.purple_dye": "Lila färg",
  "item.minecraft.purple_harness": "Lila sele",
  "item.minecraft.quartz": "Netherkvarts",
  "item.minecraft.rabbit": "Rå kanin",
  "item.minecraft.rabbit_foot": "Hartass",
  "item.minecraft.rabbit_hide": "Kaninskinn",
  "item.minecraft.rabbit_spawn_egg": "Skapelseägg för kanin",
  "item.minecraft.rabbit_stew": "Kaninstuvning",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Uppfödande rustningsdetaljer",
  "item.minecraft.ravager_spawn_egg": "Skapelseägg för ödeläggare",
  "item.minecraft.raw_copper": "Råkoppar",
  "item.minecraft.raw_gold": "Råguld",
  "item.minecraft.raw_iron": "Råjärn",
  "item.minecraft.recovery_compass": "Tillbakahittande kompass",
  "item.minecraft.red_bundle": "Röd påse",
  "item.minecraft.red_dye": "Röd färg",
  "item.minecraft.red_harness": "Röd sele",
  "item.minecraft.redstone": "Redstonedamm",
  "item.minecraft.resin_brick": "Hartstegelsten",
  "item.minecraft.resin_clump": "Hartsklump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Revbensrandiga rustningsdetaljer",
  "item.minecraft.rotten_flesh": "Ruttet kött",
  "item.minecraft.saddle": "Sadel",
  "item.minecraft.salmon": "Rå lax",
  "item.minecraft.salmon_bucket": "Hink med lax",
  "item.minecraft.salmon_spawn_egg": "Skapelseägg för lax",
  "item.minecraft.scrape_pottery_sherd": "Keramikskärva med yxa",
  "item.minecraft.scute": "Skal",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Värnande rustningsdetaljer",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Formgivande rustningsdetaljer",
  "item.minecraft.sheaf_pottery_shard": "Keramikskärva med vetekärve",
  "item.minecraft.sheaf_pottery_sherd": "Keramikskärva med vetekärve",
  "item.minecraft.shears": "Sax",
  "item.minecraft.sheep_spawn_egg": "Skapelseägg för får",
  "item.minecraft.shelter_pottery_shard": "Keramikskärva med träd",
  "item.minecraft.shelter_pottery_sherd": "Keramikskärva med träd",
  "item.minecraft.shield": "Sköld",
  "item.minecraft.shield.black": "Svart sköld",
  "item.minecraft.shield.blue": "Blå sköld",
  "item.minecraft.shield.brown": "Brun sköld",
  "item.minecraft.shield.cyan": "Turkos sköld",
  "item.minecraft.shield.gray": "Grå sköld",
  "item.minecraft.shield.green": "Grön sköld",
  "item.minecraft.shield.light_blue": "Ljusblå sköld",
  "item.minecraft.shield.light_gray": "Ljusgrå sköld",
  "item.minecraft.shield.lime": "Limegrön sköld",
  "item.minecraft.shield.magenta": "Ljuslila sköld",
  "item.minecraft.shield.orange": "Orange sköld",
  "item.minecraft.shield.pink": "Rosa sköld",
  "item.minecraft.shield.purple": "Lila sköld",
  "item.minecraft.shield.red": "Röd sköld",
  "item.minecraft.shield.white": "Vit sköld",
  "item.minecraft.shield.yellow": "Gul sköld",
  "item.minecraft.shulker_shell": "Shulkerskal",
  "item.minecraft.shulker_spawn_egg": "Skapelseägg för shulker",
  "item.minecraft.sign": "Skylt",
  "item.minecraft.silence_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ljudlösa rustningsdetaljer",
  "item.minecraft.silverfish_spawn_egg": "Skapelseägg för silverfisk",
  "item.minecraft.skeleton_horse_spawn_egg": "Skapelseägg för skeletthäst",
  "item.minecraft.skeleton_spawn_egg": "Skapelseägg för skelett",
  "item.minecraft.skull_banner_pattern": "Fanemönster",
  "item.minecraft.skull_banner_pattern.desc": "Dödskalle",
  "item.minecraft.skull_banner_pattern.new": "Fanemönster för dödskalle",
  "item.minecraft.skull_pottery_shard": "Keramikskärva med dödskalle",
  "item.minecraft.skull_pottery_sherd": "Keramikskärva med dödskalle",
  "item.minecraft.slime_ball": "Slemboll",
  "item.minecraft.slime_spawn_egg": "Skapelseägg för slemkub",
  "item.minecraft.smithing_template": "Smidesmall",
  "item.minecraft.smithing_template.applies_to": "Kan tillämpas på:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Lägg till tacka eller ädelsten",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rustningsdelar",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Lägg till rustningsdel",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Tackor och ädelstenar",
  "item.minecraft.smithing_template.ingredients": "Ingredienser:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Lägg till netherittacka",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantutrustning",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Lägg till valfri typ av diamantutrustning",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherittacka",
  "item.minecraft.smithing_template.upgrade": "Uppgradering: ",
  "item.minecraft.sniffer_spawn_egg": "Skapelseägg för sniffare",
  "item.minecraft.snort_pottery_shard": "Keramikskärva med sniffare",
  "item.minecraft.snort_pottery_sherd": "Keramikskärva med sniffare",
  "item.minecraft.snout_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Trynformade rustningsdetaljer",
  "item.minecraft.snow_golem_spawn_egg": "Skapelseägg för snögolem",
  "item.minecraft.snowball": "Snöboll",
  "item.minecraft.spectral_arrow": "Spektralpil",
  "item.minecraft.spider_eye": "Spindelöga",
  "item.minecraft.spider_spawn_egg": "Skapelseägg för spindel",
  "item.minecraft.spire_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spiraformade rustningsdetaljer",
  "item.minecraft.splash_potion": "Kastbar brygd",
  "item.minecraft.splash_potion.effect.awkward": "Kastbar tafflig brygd",
  "item.minecraft.splash_potion.effect.empty": "Kastbar icke-tillverkningsbar brygd",
  "item.minecraft.splash_potion.effect.fire_resistance": "Kastbar eldresistensbrygd",
  "item.minecraft.splash_potion.effect.harming": "Kastbar skadebrygd",
  "item.minecraft.splash_potion.effect.healing": "Kastbar läkningsbrygd",
  "item.minecraft.splash_potion.effect.infested": "Kastbar infestationsbrygd",
  "item.minecraft.splash_potion.effect.invisibility": "Kastbar osynlighetsbrygd",
  "item.minecraft.splash_potion.effect.leaping": "Kastbar hoppstrykebrygd",
  "item.minecraft.splash_potion.effect.levitation": "Kastbar levitationsbrygd",
  "item.minecraft.splash_potion.effect.luck": "Kastbar turbrygd",
  "item.minecraft.splash_potion.effect.mundane": "Kastbar banal brygd",
  "item.minecraft.splash_potion.effect.night_vision": "Kastbar mörkerseendebrygd",
  "item.minecraft.splash_potion.effect.oozing": "Kastbar slemmighetsbrygd",
  "item.minecraft.splash_potion.effect.poison": "Kastbar giftbrygd",
  "item.minecraft.splash_potion.effect.regeneration": "Kastbar återhämtningsbrygd",
  "item.minecraft.splash_potion.effect.slow_falling": "Kastbar antigravitationsbrygd",
  "item.minecraft.splash_potion.effect.slowness": "Kastbar långsamhetsbrygd",
  "item.minecraft.splash_potion.effect.strength": "Kastbar styrkebrygd",
  "item.minecraft.splash_potion.effect.swiftness": "Kastbar snabbhetsbrygd",
  "item.minecraft.splash_potion.effect.thick": "Kastbar tjock brygd",
  "item.minecraft.splash_potion.effect.turtle_master": "Sköldpaddsmästarens kastbara brygd",
  "item.minecraft.splash_potion.effect.water": "Kastbar vattenflaska",
  "item.minecraft.splash_potion.effect.water_breathing": "Kastbar vattenandningsbrygd",
  "item.minecraft.splash_potion.effect.weakness": "Kastbar svaghetsbrygd",
  "item.minecraft.splash_potion.effect.weaving": "Kastbar spindelnätsbrygd",
  "item.minecraft.splash_potion.effect.wind_charged": "Kastbar vindladdningsbrygd",
  "item.minecraft.spruce_boat": "Granbåt",
  "item.minecraft.spruce_chest_boat": "Granbåt med kista",
  "item.minecraft.spyglass": "Kikare",
  "item.minecraft.squid_spawn_egg": "Skapelseägg för bläckfisk",
  "item.minecraft.stick": "Pinne",
  "item.minecraft.stone_axe": "Stenyxa",
  "item.minecraft.stone_hoe": "Stenflåhacka",
  "item.minecraft.stone_pickaxe": "Stenhacka",
  "item.minecraft.stone_shovel": "Stenspade",
  "item.minecraft.stone_spear": "Stenspjut",
  "item.minecraft.stone_sword": "Stensvärd",
  "item.minecraft.stray_spawn_egg": "Skapelseägg för strövare",
  "item.minecraft.strider_spawn_egg": "Skapelseägg för vandrare",
  "item.minecraft.string": "Tråd",
  "item.minecraft.sugar": "Socker",
  "item.minecraft.suspicious_stew": "Misstänksam stuvning",
  "item.minecraft.sweet_berries": "Söta bär",
  "item.minecraft.tadpole_bucket": "Hink med grodyngel",
  "item.minecraft.tadpole_spawn_egg": "Skapelseägg för grodyngel",
  "item.minecraft.tide_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tidvattenvågsprydda rustningsdetaljer",
  "item.minecraft.tipped_arrow": "Förtrollad pil",
  "item.minecraft.tipped_arrow.effect.awkward": "Förtrollad pil",
  "item.minecraft.tipped_arrow.effect.empty": "Icke-tillverkningsbar förtrollad pil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Eldresistenspil",
  "item.minecraft.tipped_arrow.effect.harming": "Skadepil",
  "item.minecraft.tipped_arrow.effect.healing": "Läkningspil",
  "item.minecraft.tipped_arrow.effect.infested": "Infestationspil",
  "item.minecraft.tipped_arrow.effect.invisibility": "Osynlighetspil",
  "item.minecraft.tipped_arrow.effect.leaping": "Hoppstyrkepil",
  "item.minecraft.tipped_arrow.effect.levitation": "Levitationspil",
  "item.minecraft.tipped_arrow.effect.luck": "Turpil",
  "item.minecraft.tipped_arrow.effect.mundane": "Förtrollad pil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Mörkerseendepil",
  "item.minecraft.tipped_arrow.effect.oozing": "Slemmighetspil",
  "item.minecraft.tipped_arrow.effect.poison": "Giftpil",
  "item.minecraft.tipped_arrow.effect.regeneration": "Återhämtningspil",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Antigravitationspil",
  "item.minecraft.tipped_arrow.effect.slowness": "Långsamhetspil",
  "item.minecraft.tipped_arrow.effect.strength": "Styrkepil",
  "item.minecraft.tipped_arrow.effect.swiftness": "Snabbhetspil",
  "item.minecraft.tipped_arrow.effect.thick": "Förtrollad pil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Sköldpaddsmästarens pil",
  "item.minecraft.tipped_arrow.effect.water": "Stänkande pil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Vattenandningspil",
  "item.minecraft.tipped_arrow.effect.weakness": "Svaghetspil",
  "item.minecraft.tipped_arrow.effect.weaving": "Spindelnätspil",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vindladdningspil",
  "item.minecraft.tnt_minecart": "Gruvvagn med dynamit",
  "item.minecraft.torchflower_seeds": "Fackelliljefrön",
  "item.minecraft.totem_of_undying": "Odödlighetstotem",
  "item.minecraft.trader_llama_spawn_egg": "Skapelseägg för byteshandlarlama",
  "item.minecraft.trial_key": "Utmaningsnyckel",
  "item.minecraft.trident": "Treudd",
  "item.minecraft.tropical_fish": "Tropisk fisk",
  "item.minecraft.tropical_fish_bucket": "Hink med tropisk fisk",
  "item.minecraft.tropical_fish_spawn_egg": "Skapelseägg för tropisk fisk",
  "item.minecraft.turtle_helmet": "Sköldpaddsskal",
  "item.minecraft.turtle_scute": "Sköldpaddsskal",
  "item.minecraft.turtle_spawn_egg": "Skapelseägg för sköldpadda",
  "item.minecraft.vex_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Osaliga rustningsdetaljer",
  "item.minecraft.vex_spawn_egg": "Skapelseägg för osalig ande",
  "item.minecraft.villager_spawn_egg": "Skapelseägg för bybo",
  "item.minecraft.vindicator_spawn_egg": "Skapelseägg för försvarare",
  "item.minecraft.wandering_trader_spawn_egg": "Skapelseägg för vandrande byteshandlare",
  "item.minecraft.ward_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Vaktande rustningsdetaljer",
  "item.minecraft.warden_spawn_egg": "Skapelseägg för vakt",
  "item.minecraft.warped_fungus_on_a_stick": "Förvrängd svamp på pinne",
  "item.minecraft.water_bucket": "Vattenhink",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Vägvisande rustningsdetaljer",
  "item.minecraft.wheat": "Vete",
  "item.minecraft.wheat_seeds": "Vetefrön",
  "item.minecraft.white_bundle": "Vit påse",
  "item.minecraft.white_dye": "Vit färg",
  "item.minecraft.white_harness": "Vit sele",
  "item.minecraft.wild_armor_trim_smithing_template": "Smidesmall",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Vildsinta rustningsdetaljer",
  "item.minecraft.wind_charge": "Vindladdning",
  "item.minecraft.witch_spawn_egg": "Skapelseägg för häxa",
  "item.minecraft.wither_skeleton_spawn_egg": "Skapelseägg för witherskelett",
  "item.minecraft.wither_spawn_egg": "Skapelseägg för Wither",
  "item.minecraft.wolf_armor": "Vargrustning",
  "item.minecraft.wolf_spawn_egg": "Skapelseägg för varg",
  "item.minecraft.wooden_axe": "Träyxa",
  "item.minecraft.wooden_hoe": "Träflåhacka",
  "item.minecraft.wooden_pickaxe": "Trähacka",
  "item.minecraft.wooden_shovel": "Träspade",
  "item.minecraft.wooden_spear": "Träspjut",
  "item.minecraft.wooden_sword": "Träsvärd",
  "item.minecraft.writable_book": "Bok och fjäderpenna",
  "item.minecraft.written_book": "Skriven bok",
  "item.minecraft.yellow_bundle": "Gul påse",
  "item.minecraft.yellow_dye": "Gul färg",
  "item.minecraft.yellow_harness": "Gul sele",
  "item.minecraft.zoglin_spawn_egg": "Skapelseägg för zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Skapelseägg för zombiehäst",
  "item.minecraft.zombie_nautilus_spawn_egg": "Skapelseägg för zombiepärlbåt",
  "item.minecraft.zombie_spawn_egg": "Skapelseägg för zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Skapelseägg för zombiebybo",
  "item.minecraft.zombified_piglin_spawn_egg": "Skapelseägg för zombifierad piglin"
}
export const sv_se = items; 
